<template>
  <div class="row mt-4">
    <div class="col-12 col-md">
      <b-tabs v-model="activeTab" ref="tabs" content-class="mt-3" justified>
        <b-tab title="Agregar nuevo curso" active>
          <b-form class="row" @submit.prevent="addCursoAcademia">
            <div class="col-12 col-lg mt-2 d-flex flex-column justify-content-center align-items-center">
              <label for=" " class="form-label">
                <em class="text-danger font-weight-bolder">Imagen vista previa:</em>
              </label>
              <!-- image preview -->
              <div class="image-container w-100 rounded bg-dark">
                <input type="file" ref="fileInput" @change="previewImage" class="file-input" @click.stop
                  accept="image/*" />
                <div v-if="!imagePreview" class="placeholder" @click="openFileInput">
                  Haz clic para seleccionar una imagen
                </div>
                <img v-if="imagePreview" :src="imagePreview" alt="Preview" class="preview-image" />
                <i v-if="imagePreview" @click="removeImage" class="fas fa-circle-minus position-absolute text-danger"
                  style="
                    top: 0;
                    right: -30px;
                    transform: translate(-50%, -50%);
                    font-size: 1.5rem;
                  ">
                </i>
              </div>
            </div>
            <div class="col-12 col-md">
              <!-- title -->
              <div class="mt-2">
                <b-form-group id="title" label-for="title">
                  <template #label>
                    <em class="text-danger font-weight-bold">Título: </em>
                  </template>
                  <b-form-input id="title" v-model="newCourse.titulo" placeholder="Titulo del curso" required />
                </b-form-group>
              </div>

              <!-- descripcion -->
              <div class="mt-2">
                <b-form-group id="textarea" label-for="textarea">
                  <template #label>
                    <em class="text-danger font-weight-bold">Descripción: </em>
                  </template>
                  <b-form-textarea id="textarea" v-model="newCourse.descripcion" placeholder="Descripcion del curso..."
                    rows="3" max-rows="6" required></b-form-textarea>
                </b-form-group>
              </div>
              <!-- categoria del curso -->
              <div class="mt-2">
                <div>
                  <label for=" " class="form-label">
                    <em class="text-danger font-weight-bolder">Categoría:</em>
                  </label>
                  <!-- vue-select -->
                  <div class="d-flex">
                    <div class="pr-2" style="
                        background: transparent;
                        padding: 0rem;
                        width: 100%;
                      ">
                      <v-select v-model="newCourse.categoriaCursoId" class="style-chooser" :reduce="(value) => value.Id"
                        :options="listaCategoriaCursos.data" :get-option-label="(option) => `${option.Descripcion}`"
                        placeholder="-- seleccionar categoría --">
                        <!-- required -->
                        <template #search="{ attributes, events }">
                          <input class="vs__search" :required="!newCourse.categoriaCursoId" v-bind="attributes"
                            v-on="events" />
                        </template>
                        <!-- sin resultados en la busqueda -->
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            No se encontraron resultados para
                            <em class="text-danger">{{ search }}</em>.
                          </template>
                          <em v-else style="opacity: 0.5">No hay tipos de empresa para mostrar.</em>
                        </template>
                      </v-select>
                    </div>
                    <div style="margin-top: -5px">
                      <vs-button @click="modalCategoria()" v-b-tooltip.hover title="Crear categoria" icon primary>
                        <i class="fa-solid fa-circle-plus mt-0"></i>
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- certificación -->
              <div class="mt-2">
                <div>
                  <label for=" " class="form-label">
                    <em class="text-danger font-weight-bolder">Certificado Finalización:</em>
                  </label>
                  <!-- vue-select -->
                  <div style="background: transparent; padding: 0rem">
                    <v-select v-model="newCourse.certificadoFinalizacion" class="style-chooser"
                      :reduce="(value) => value.value" :options="optionsCertificacion"
                      :get-option-label="(option) => `${option.text}`" placeholder="-- seleccionar una opción --">
                      <!-- required -->
                      <template #search="{ attributes, events }">
                        <input class="vs__search" :required="!newCourse.certificadoFinalizacion" v-bind="attributes"
                          v-on="events" />
                      </template>
                      <!-- sin resultados en la busqueda -->
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          No se encontraron resultados para
                          <em class="text-danger">{{ search }}</em>.
                        </template>
                        <em v-else style="opacity: 0.5">No hay opciones para mostrar.</em>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <!-- privacidad del curso -->
              <div class="mt-2 row">
                <div class="col-8">
                  <label for=" " class="form-label">
                    <em class="text-danger font-weight-bolder">Privacidad:</em>
                  </label>
                  <!-- vue-select -->
                  <div style="background: transparent; padding: 0rem">
                    <!-- <v-select v-model="newCourse.privacidad" class="style-chooser" :reduce="(value) => value.value"
                      :options="optionsPrivacidadCursos" :get-option-label="(option) => `${option.text}`"
                      placeholder="-- seleccionar una opción --"> -->
                    <v-select v-model="newCourse.Privacidad" class="style-chooser" :reduce="(value) => value.value"
                      :options="optionsPrivacidadCursos" :get-option-label="(option) => `${option.text}`"
                      placeholder="-- seleccionar una opción --">
                      <!--  agregar contenido adicional a las opciones-->
                      <template v-slot:option="option">
                        <i :class="`fas fa-${option.icon}`"></i>
                        {{ option.text }}
                      </template>
                      <!-- required -->
                      <template #search="{ attributes, events }">
                        <input class="vs__search" v-bind="attributes" v-on="events" />
                      </template>
                      <!-- sin resultados en la busqueda -->
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          No se encontraron resultados para
                          <em class="text-danger">{{ search }}</em>.
                        </template>
                        <em v-else style="opacity: 0.5">No hay opciones para mostrar.</em>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-4">
                  <label for=" " class="form-label">
                    <em class="text-danger font-weight-bolder">Matricula Publica</em>
                  </label>
                  <div style="background: transparent; padding: 0rem">
                    <vs-checkbox v-model="newCourse.InscripcionPublica" class="style-chooser"
                      :reduce="(value) => value.value" placeholder="-- seleccionar una opción --">
                    </vs-checkbox>
                  </div>
                </div>
              </div>
              <!-- calificacion curso -->
              <div class="row">
                <div class="col-md-6 mt-2">
                  <b-form-group id="title" label-for="title">
                    <template #label>
                      <em class="text-danger font-weight-bold">Nota mínima de aprobación:
                      </em>
                    </template>
                    <b-form-input step="0.01" min="0" type="number" id="title" v-model="newCourse.notaMinima"
                      placeholder="Nota mínima" />
                  </b-form-group>
                </div>
                <div class="col-md-6 pl-lg-0 mt-2">
                  <b-form-group id="title" label-for="title">
                    <template #label>
                      <em class="text-danger font-weight-bold">Nota maxima de aprobación:
                      </em>
                    </template>
                    <b-form-input step="0.01" min="0" type="number" id="title" v-model="newCourse.notaMaxima"
                      placeholder="Nota maxima" />
                  </b-form-group>
                </div>
              </div>
              <!-- btn submit -->
              <div class="d-flex justify-content-end mt-2">
                <vs-button animation-type="scale" :loading="isLoading" danger size="large" style="min-width: 150px">
                  <i class="fas fa-circle-plus"></i>
                  <template #animate> Agregar curso</template>
                </vs-button>
              </div>
            </div>
          </b-form>
        </b-tab>
        <b-tab title="Listado de cursos" @click="onResize">
          <b-form-group id="filterForTitle" label-for="filterForTitle" class="container-fluid">
            <template #label>
              <em class="text-danger font-weight-bold">Filtrar por título: </em>
            </template>
            <div class="d-flex align-items-center">
              <b-form-input type="search" id="filterForTitle" placeholder="Empieza la búsqueda" class="flex-grow-1 mr-2"
                v-model="searchedTitleCursos">
              </b-form-input>
              <vs-button @click="BuscarPorTitulo" title="Buscar" success icon>
                <i class="fa-solid fa-magnifying-glass"></i>
              </vs-button>
            </div>
          </b-form-group>
          <!-- lista de cursos -->
          <div v-if="isLoadingCurso && listaCursosAcademia.length === 0">
            <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
          </div>
          <div v-else>
            <div v-if="listaCursosAcademia.length > 0" class="row list-videos justify-content-center mt-5 px-2"
              ref="cursosContainer" @scroll="handleScroll">
              <div v-for="(curso, index) in listaCursosAcademia" :key="curso.id"
                class="col-12 col-lg-5 d-flex align-items-center py-2 bg-dark rounded" :style="{
                  transition: 'box-shadow 0.3s ease',
                  boxShadow:
                    activeCardVideoCursos === index
                      ? 'inset 0 0 0 2px #186bdd '
                      : 'none',
                  cursor: 'default',
                }">
                <!-- acciones  -->
                <b-dropdown class="position-absolute" style="top: 0; right: 0; z-index: 10" size="sm" variant="link"
                  toggle-class="text-decoration-none" no-caret>
                  <template #button-content>
                    <i class="fas fa-ellipsis" style="font-size: 1.5rem"></i>
                  </template>
                  <b-dropdown-item-button v-b-modal="'modalAdminCurso'" @click="
                    cursoId = curso.id;
                  getInfoClasesCursoAcademia(curso.id);
                  ">
                    <i class="fas fa-gear"></i>
                    {{ curso.Habilitado ? "Visualizar" : "Administrar" }}
                  </b-dropdown-item-button>
                  <b-dropdown-item-button v-if="curso.Habilitado" @click="ClonarCurso(curso.id)">
                    <i class="fas fa-copy"></i>
                    Clonar Curso
                  </b-dropdown-item-button>
                  <b-dropdown-item-button v-if="curso.Habilitado" @click="DeshabilitarCurso(curso.id)">
                    <i class="fas fa-copy"></i>
                    Deshabilitar Curso
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="ObtenerSeguimientoCurso(curso.id)" v-if="curso.Habilitado">
                    <i class="fa fa-graduation-cap"></i>
                    Seguimiento
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="modalUpdateCurso(curso)" v-if="!curso.Habilitado">
                    <i class="fas fa-edit"></i> Editar
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="deleteCursoAcademia(curso.id)">
                    <i class="fas fa-trash text-danger"></i>
                    <span class="text-danger ml-1">Eliminar</span>
                  </b-dropdown-item-button>
                </b-dropdown>
                <div class="row w-100">
                  <div class="col-12 col-lg-4 pr-lg-0 d-flex align-items-center mt-2 mt-lg-0">
                    <div class="image-container-preview">
                      <ContenidoHelexium :fileId="curso.previewImagenUrl" :alt="curso.titulo"
                        :BotonDescargarArchivos="false" />
                      <!-- <img src="imagen2.jpg" alt="Imagen 2"> -->
                    </div>
                    <!-- <img class="rounded w-100 " :src="curso.previewImagenUrl ?? '/img/image_cursos_alt.png'"
                         :alt="curso.titulo"/> -->
                  </div>
                  <div class="col-12 col-md-8 my-4 overflow-hidden">
                    <span class="font-weight-bold h4 text-capitalize">{{
                      curso.titulo
                    }}</span>
                    <p class="text-white-50 m-0 custom-descripcion">
                      {{ curso.descripcion }}
                    </p>
                    <vs-tooltip v-if="showReadMoreDesc[index]" class="d-inline" right>
                      <small class="text-capitalize font-italic text-primary">
                        leer más
                      </small>
                      <template #tooltip>
                        <div class="content-tooltip text-left overflow-hidden">
                          <p class="text-break" style="color: inherit">
                            {{ curso.descripcion }}
                          </p>
                        </div>
                      </template>
                    </vs-tooltip>
                    <div class="d-flex align-items-center">
                      <small class="custom-punto d-flex align-items-center">{{
                        curso.categoriaCurso
                      }}</small>
                      <b-badge :variant="!curso.privacidad ? 'success' : 'danger'">
                        {{ !curso.privacidad ? "Público" : "Privado" }}
                      </b-badge>
                      <b-badge style="margin-left: 8px" v-if="curso.Habilitado" variant="primary">
                        Habilitado
                      </b-badge>
                    </div>
                    <small class="d-flex align-items-center mt-2 text-white-50">
                      <i class="fas fa-circle-check mr-1"></i>
                      última actualización
                      <span class="text-primary ml-1">
                        {{
                          curso.ultimaActualizacion | formatLastUpdateDate
                        }}</span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="isLoadingCurso">
              <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
            </div>
            <template v-else>
              <div class="d-flex flex-column align-items-center justify-content-center">
                <p class="h4 text-white-50">No hay curso para mostrar...</p>
              </div>
            </template>
          </div>
        </b-tab>
        <b-tab title="Seguimiento de cursos" @click="onResize">
          <div class="row align-items-center pb-3">
            <div class="col-8 col-md-4">
              <label for="Nombre">Curso *</label>
              <b-form-select name="Curso" v-model="cursoSeguimientoId" :options="ListaCursosSelect" :value-field="'id'"
                :text-field="'titulo'" @change="$refs.dataTableLotes.$emit('actualizar')"
                placeholder="-- Selecciona un curso --" required>
                <template #selected="{ option }">
                  {{ option?.titulo || "-- Selecciona un curso --" }}
                </template>
                <template #first>
                  <b-form-select-option value="">-- Seleccionar un curso --</b-form-select-option>
                </template>
              </b-form-select>
            </div>
            <div class="col-8 col-md-4">
              <label for="Nombre">Añadir personas</label>
              <vs-button icon @click="AbrilModalSeguimiento" :disabled="cursoSeguimientoId === ''">
                <i class="fas fa-address-book"></i>
              </vs-button>
            </div>
          </div>
          <DataTableLotes ref="dataTableLotes" :fetch-data="fetchData" :columns="columns" :busqueda-boton="true" :EXportarExcel="true">
            <template v-slot:Completado="{ row }">
              {{ row.Completado }}
            </template>
            <template v-slot:Id="{ row }">
              <b-button @click="obtenerNotas(row.CursoId, row.PersonaId)">
                Notas
              </b-button>
            </template>
          </DataTableLotes>
        </b-tab>
      </b-tabs>
    </div>

    <b-modal id="modalEvaluacionesAdministracion" title="Evaluaciones" hide-footer centered size="xl">
      <div v-if="NotasCurso.length === 0">
        No hay evaluaciones cargadas para esta clase
      </div>
      <b-table v-else striped hover :items="NotasCurso" :fields="[
        'Titulo',
        'Nota',
        'FechaInicio',
        'FechaFin',
        'FechaAplicacion',
        'Opciones',
      ]">
        <template #cell(FechaInicio)="data">
          <vs-input type="datetime-local" v-model="data.item.FechaInicio" :min="fechaActual"></vs-input>
        </template>
        <!-- Fecha de Fin Editable -->
        <template #cell(FechaFin)="data">
          <vs-input :disabled="data.item.FechaInicio === null" type="datetime-local" v-model="data.item.FechaFin"
            :min="data.item.FechaInicio"></vs-input>
        </template>
        <template #cell(FechaAplicacion)="data">
          {{
            data.item.FechaAplicacion
              ? formatoFechaHora(data.item.FechaAplicacion)
              : "Fecha No Registrada"
          }}
        </template>
        <template #cell(Opciones)="data">
          <vs-button @click="
            guardarFecha(
              data.item.FechaInicio,
              data.item.FechaFin,
              data.item.Id
            )
            ">Guardar</vs-button>
        </template>
      </b-table>
    </b-modal>
    <!-- update curso modal -->
    <b-modal id="modalUpdateCurso" title="Editar Curso" hide-footer centered size="xl">
      <b-form class="row" @submit.prevent="updateCursoAcademia">
        <div class="col-12 col-lg mt-2 d-flex flex-column justify-content-center align-items-center">
          <label for=" " class="form-label">
            <em class="text-danger font-weight-bolder">Imagen vista previa:
            </em>
          </label>
          <!-- image preview -->
          <div class="image-container rounded bg-dark w-100">
            <input type="file" ref="fileInput" @change="previewImage" :disabled="filterDataModalUpdateCurso.Habilitado"
              class="file-input" @click.stop accept="image/*" />
            <div v-if="!filterDataModalUpdateCurso.previewImagenUrl" class="placeholder" @click="openFileInput">
              Haz clic para seleccionar una imagen
            </div>
            <contenidoHelexium v-if="filterDataModalUpdateCurso.previewImagenUrl"
              :fileId="filterDataModalUpdateCurso.previewImagenUrl" :alt="filterDataModalUpdateCurso.titulo"
              style="height: 200px; overflow:hidden" :BotonDescargarArchivos="false" />
            <i v-if="filterDataModalUpdateCurso.previewImagenUrl" @click="removeImage"
              class="fas fa-circle-minus position-absolute text-danger" style="
                top: 0;
                right: -30px;
                transform: translate(-50%, -50%);
                font-size: 1.5rem;
              ">
            </i>
          </div>
        </div>
        <div class="col-12 col-md">
          <!-- title -->
          <div class="mt-2">
            <b-form-group id="title" label-for="title">
              <template #label>
                <em class="text-danger font-weight-bold">Título: </em>
              </template>
              <b-form-input id="title" v-model="filterDataModalUpdateCurso.titulo" placeholder="Titulo del curso"
                :disabled="filterDataModalUpdateCurso.Habilitado" required></b-form-input>
            </b-form-group>
          </div>
          <!-- descripcion -->
          <div class="mt-2">
            <b-form-group id="textarea" label-for="textarea">
              <template #label>
                <em class="text-danger font-weight-bold">Descripción: </em>
              </template>
              <b-form-textarea id="textarea" v-model="filterDataModalUpdateCurso.descripcion"
                placeholder="Descripcion del curso..." rows="3" max-rows="6" required
                :disabled="filterDataModalUpdateCurso.Habilitado"></b-form-textarea>
            </b-form-group>
          </div>
          <!-- categoria del curso -->
          <div class="mt-2">
            <div>
              <label for=" " class="form-label">
                <em class="text-danger font-weight-bolder">Categoría:</em>
              </label>
              <!-- vue-select -->
              <div class="d-flex">
                <div class="pr-2" style="background: transparent; padding: 0rem; width: 100%">
                  <v-select v-model="filterDataModalUpdateCurso.categoriaCursoId" class="style-chooser"
                    :reduce="(value) => value.Id" :options="listaCategoriaCursos.data"
                    :disabled="filterDataModalUpdateCurso.Habilitado"
                    :get-option-label="(option) => `${option.Descripcion}`" placeholder="-- seleccionar categoría --">
                    <!-- required -->
                    <template #search="{ attributes, events }">
                      <input class="vs__search" :required="!filterDataModalUpdateCurso.categoriaCursoId"
                        v-bind="attributes" v-on="events" />
                    </template>
                    <!-- sin resultados en la busqueda -->
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No se encontraron resultados para
                        <em class="text-danger">{{ search }}</em>.
                      </template>
                      <em v-else style="opacity: 0.5">No hay tipos de empresa para mostrar.</em>
                    </template>
                  </v-select>
                </div>
                <div style="margin-top: -5px">
                  <vs-button @click.stop.prevent="modalCategoria()" v-b-tooltip.hover title="Crear categoria" icon
                    primary v-if="!filterDataModalUpdateCurso.Habilitado">
                    <i class="fa-solid fa-circle-plus mt-0"></i>
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
          <!-- certificacion -->
          <div class="mt-2">
            <div>
              <label for=" " class="form-label">
                <em class="text-danger font-weight-bolder">Certificado Finalización:</em>
              </label>
              <!-- vue-select -->
              <div style="background: transparent; padding: 0rem">
                <v-select v-model="filterDataModalUpdateCurso.certificadoFinalizacion" class="style-chooser"
                  :reduce="(value) => value.value" :options="optionsCertificacion"
                  :disabled="filterDataModalUpdateCurso.Habilitado" :get-option-label="(option) => `${option.text}`"
                  placeholder="-- seleccionar una opción --">
                  <!-- required -->
                  <template #search="{ attributes, events }">
                    <input class="vs__search" :required="!filterDataModalUpdateCurso.certificadoFinalizacion
                      " v-bind="attributes" v-on="events" />
                  </template>
                  <!-- sin resultados en la busqueda -->
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                      No se encontraron resultados para
                      <em class="text-danger">{{ search }}</em>.
                    </template>
                    <em v-else style="opacity: 0.5">No hay opciones para mostrar.</em>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <!-- privacidad del curso -->
          <div class="mt-2 row">
            <div class="col-9">
              <label for=" " class="form-label">
                <em class="text-danger font-weight-bolder">Privacidad:</em>
              </label>
              <!-- vue-select -->
              <div style="background: transparent; padding: 0rem">
                <v-select v-model="filterDataModalUpdateCurso.privacidad" class="style-chooser"
                  :reduce="(value) => value.value" :options="optionsPrivacidadCursos"
                  :disabled="filterDataModalUpdateCurso.Habilitado" :get-option-label="(option) => `${option.text}`"
                  placeholder="-- seleccionar una opción --">
                  <!--  agregar contenido adicional a las opciones-->
                  <template v-slot:option="option">
                    <i :class="`fas fa-${option.icon}`"></i>
                    {{ option.text }}
                  </template>
                  <!-- required -->
                  <template #search="{ attributes, events }">
                    <input class="vs__search" :required="filterDataModalUpdateCurso.privacidad == null ||
                      filterDataModalUpdateCurso.privacidad == undefined
                      " v-bind="attributes" v-on="events" />
                  </template>
                  <!-- sin resultados en la busqueda -->
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                      No se encontraron resultados para
                      <em class="text-danger">{{ search }}</em>.
                    </template>
                    <em v-else style="opacity: 0.5">No hay opciones para mostrar.</em>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="col-3">
              <label for=" " class="form-label">
                <em class="text-danger font-weight-bolder">Matricula Publica</em>
              </label>
              <div style="background: transparent; padding: 0rem">
                <vs-checkbox v-model="filterDataModalUpdateCurso.InscripcionPublica" class="style-chooser"
                  :reduce="(value) => value.value" :class="{
                    'disabled-checkbox': filterDataModalUpdateCurso.Habilitado,
                  }" placeholder="-- seleccionar una opción --">
                </vs-checkbox>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mt-2">
              <b-form-group id="title" label-for="title">
                <template #label>
                  <em class="text-danger font-weight-bold">Nota mínima de aprobación:
                  </em>
                </template>
                <b-form-input step="0.01" min="0" type="number" id="title"
                  :disabled="filterDataModalUpdateCurso.Habilitado" v-model="filterDataModalUpdateCurso.notaMinima"
                  placeholder="Nota mínima" />
              </b-form-group>
            </div>
            <div class="col-md-6 pl-lg-0 mt-2">
              <b-form-group id="title" label-for="title">
                <template #label>
                  <em class="text-danger font-weight-bold">Nota maxima de aprobación:
                  </em>
                </template>
                <b-form-input step="0.01" min="0" type="number" id="title"
                  :disabled="filterDataModalUpdateCurso.Habilitado" v-model="filterDataModalUpdateCurso.notaMaxima"
                  placeholder="Nota maxima" />
              </b-form-group>
            </div>
          </div>
          <!-- btn submit -->
          <div class="d-flex justify-content-end mt-2">
            <vs-button type="submit" animation-type="scale" :loading="isLoading" danger size="large"
              style="min-width: 150px" v-if="!filterDataModalUpdateCurso.Habilitado">
              <i class="fas fa-circle-check"></i>
              <template #animate> Actualizar curso</template>
            </vs-button>
          </div>
        </div>
      </b-form>
    </b-modal>
    <!-- admin curso modal -->
    <b-modal id="modalAdminCurso" title="Administrar Curso" size="xl" hide-footer centered>
      <b-card bg-variant="dark">
        <div class="row">
          <div class="col-12 col-lg-4 d-flex align-items-center">
            <ContenidoHelexium class="rounded w-100" :fileId="filterDataModalUpdateCurso.previewImagenUrl"
              :alt="filterDataModalUpdateCurso.titulo" :BotonDescargarArchivos="false" />
          </div>
          <div class="col mt-3 mt-md-0 content-desc overflow-hidden">
            <span class="font-weight-bold h3 text-capitalize">
              {{ filterDataModalUpdateCurso.titulo }}
            </span>
            <p class="text-white-50 m-0 h4 custom-descripcion mb-1">
              {{ filterDataModalUpdateCurso.descripcion }}
            </p>
            <vs-tooltip v-if="
              showReadMoreDesc[
              listaCursosAcademia.findIndex(
                (curso) => curso.id === filterDataModalUpdateCurso.id
              )
              ]
            " class="d-inline" style="cursor: default" right>
              <span class="text-capitalize font-italic text-primary">leer más</span>
              <template #tooltip>
                <div class="content-tooltip text-left overflow-hidden">
                  <p class="text-break h4" style="color: inherit">
                    {{ filterDataModalUpdateCurso.descripcion }}
                  </p>
                </div>
              </template>
            </vs-tooltip>
            <div class="d-flex align-items-center">
              <span class="custom-punto d-flex align-items-center font-weight-bold">
                {{ filterDataModalUpdateCurso.categoriaCurso }}
              </span>
              <b-badge :variant="!filterDataModalUpdateCurso.privacidad ? 'success' : 'danger'
                ">
                {{
                  !filterDataModalUpdateCurso.privacidad ? "Público" : "Privado"
                }}
              </b-badge>
            </div>
            <span class="d-flex align-items-center mt-2 text-white-50">
              <i class="fas fa-circle-check mr-1"></i>
              última actualización
              <span class="text-primary ml-1">
                {{
                  filterDataModalUpdateCurso.ultimaActualizacion
                  | formatLastUpdateDate
                }}
              </span>
            </span>
            <vs-button v-if="!filterDataModalUpdateCurso.Habilitado"
              @click="habilitarCurso(filterDataModalUpdateCurso.id)">Habilitar curso</vs-button>
          </div>
        </div>
      </b-card>
      <!-- Buscador y boton de creacion de clases -->
      <div class="row align-items-center">
        <div :class="!filterDataModalUpdateCurso.Habilitado
          ? 'col-12 col-lg-9'
          : 'col-12 col-lg-12'
          ">
          <b-form-input type="search" id="filterForTitle" placeholder="Filtrar clases por título"
            v-model="searchedTitleClase" required></b-form-input>
        </div>
        <div class="col d-flex mt-2 mt-lg-0">
          <vs-button v-b-modal="'modalAgregarClase'" class="w-100" style="height: 40px" :active="active === 1"
            @click="active = 1" v-if="!filterDataModalUpdateCurso.Habilitado">
            <i class="fas fa-circle-plus mr-1" style="font-size: 1.2rem"></i>
            Agregar nueva clase
          </vs-button>
        </div>
      </div>
      <!-- listado de clases -->
      <div v-if="LoadingCursos">
        <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
      </div>
      <div v-else class="row list-videos justify-content-center mt-5 px-2">
        <div v-if="filterVideosClase.length == 0" class="pb-5">
          <p class="h4">No hay clases para mostrar...</p>
        </div>
        <div v-else class="col-12">
          <div v-for="(clase, index) in filterVideosClase" :key="clase.id">
            <!-- acciones  -->
            <div @click="cardActiveClase(index)" class="col-12 d-flex align-items-center py-2 bg-dark rounded" :style="{
              transition: 'box-shadow 0.3s ease',
              boxShadow:
                activeCardVideoClase === index
                  ? 'inset 0 0 0 2px #186bdd '
                  : 'none',
              cursor: 'default',
            }">
              <b-dropdown class="position-absolute" style="top: 0; right: 0" size="sm" variant="link"
                v-if="!filterDataModalUpdateCurso.Habilitado" toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fas fa-ellipsis" style="font-size: 1.5rem"></i>
                </template>
                <b-dropdown-item-button v-b-modal="'modalUpdateClase'">
                  <i class="fas fa-edit"></i> Editar
                </b-dropdown-item-button>
                <b-dropdown-item-button @click="deleteVideoClase(clase.id)">
                  <i class="fas fa-trash text-danger"></i>
                  <span class="text-danger ml-1">Eliminar</span>
                </b-dropdown-item-button>
              </b-dropdown>
              <div class="row w-100">
                <div class="col d-flex justify-content-center align-items-center">
                  <div class="p-2 p-lg-3 rounded-circle" style="
                      box-shadow: 0 -1px 33px -8px rgba(122, 215, 0, 0.69);
                      -webkit-box-shadow: 0 -1px 33px -8px
                        rgba(122, 215, 0, 0.69);
                      -moz-box-shadow: 0 -1px 33px -8px rgba(122, 215, 0, 0.69);
                      background-color: rgba(122, 215, 0, 0.69);
                    ">
                    <i class="fa fa-book" style="font-size: 2rem"></i>
                  </div>
                </div>
                <div class="col-9 my-2 overflow-hidden my-3">
                  <h4 class="font-weight-bold text-capitalize">
                    {{ clase.titulo }}
                  </h4>
                  <p class="text-white-50 m-0 custom-descripcion">
                    {{ clase.descripcion }}
                  </p>
                  <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                    <i class="fas fa-circle-check mr-1"></i>
                    <small class="custom-punto d-flex align-items-center">
                      última actualización
                      <span class="ml-1 text-primary">
                        {{ clase.ultimaAcatualizacion | formatLastUpdateDate }}
                      </span>
                    </small>
                    <i class="fas fa-clock mr-1"></i>
                    <span class=" ">{{ clase.duracion }} min</span>
                  </div>
                </div>
              </div>
            </div>
            <b-collapse :visible="activeCardVideoClase === index" :id="'collapse-' + index" class="mt-2"
              ref="collapseRefsClass">
              <b-tabs content-class="mt-3" justified lazy>
                <b-tab title="Listado de contenidos" active>
                  <div v-if="!loadingStates[index]">
                    <div class="align-items-center">
                      <div class="d-flex justify-content-center ml-0 px-2 mt-2 mt-lg-0">
                        <vs-button class="w-100" v-if="!filterDataModalUpdateCurso.Habilitado"
                          @click="modalAgregarContenido(clase)" style="height: 40px" :active="active === 1">
                          <i class="fas fa-circle-plus mr-1" style="font-size: 1.2rem"></i>
                          Agregar nuevo contenido
                        </vs-button>
                      </div>
                    </div>
                    <div v-if="listaContenidoClases.length === 0">
                      No hay contenidos aun cargados
                    </div>
                    <div v-else>
                      <div v-for="clase in filterContenidoClases" :key="clase.id" class="col-12 py-1">
                        <div class="col-12 d-flex align-items-center py-2 bg-dark rounded">
                          <b-dropdown class="position-absolute" style="top: 0; right: 0" size="sm" variant="link"
                            toggle-class="text-decoration-none" no-caret>
                            <template #button-content>
                              <i class="fas fa-ellipsis" style="font-size: 1.5rem"></i>
                            </template>
                            <b-dropdown-item-button @click="modalEditarContenido(clase)">
                              <i class="fas fa-edit"></i>
                              {{
                                filterDataModalUpdateCurso.Habilitado
                                  ? "Visualizar"
                                  : "Editar"
                              }}
                            </b-dropdown-item-button>
                            <b-dropdown-item-button @click="deleteContenidoAcademia(clase.ID)"
                              v-if="!filterDataModalUpdateCurso.Habilitado">
                              <i class="fas fa-trash text-danger"></i>
                              <span class="text-danger ml-1">Eliminar</span>
                            </b-dropdown-item-button>
                          </b-dropdown>
                          <div class="row w-100">
                            <div class="col d-flex justify-content-center align-items-center">
                              <div :class="clase.Tipo == 'documento'
                                ? 'bg-primary'
                                : clase.Tipo == 'video'
                                  ? 'bg-danger'
                                  : clase.Tipo == 'imagen'
                                    ? 'bg-warning'
                                    : 'bg-purple'
                                " :style="clase.Tipo == 'documento'
                                  ? 'box-shadow: 0 -1px 33px -8px var(--blue); -webkit-box-shadow: 0 -1px 33px -8px var(--blue); -moz-box-shadow: 0 -1px 33px -8px var(--blue);'
                                  : clase.Tipo == 'video'
                                    ? 'box-shadow: 0 -1px 33px -8px var(--red); -webkit-box-shadow: 0 -1px 33px -8px var(--red); -moz-box-shadow: 0 -1px 33px -8px var(--red);'
                                    : clase.Tipo == 'imagen'
                                      ? 'box-shadow: 0 -1px 33px -8px var(--yellow); -webkit-box-shadow: 0 -1px 33px -8px var(--yellow); -moz-box-shadow: 0 -1px 33px -8px var(--yellow);'
                                      : 'box-shadow: 0 -1px 33px -8px var(--cyan); -webkit-box-shadow: 0 -1px 33px -8px var(--cyan); -moz-box-shadow: 0 -1px 33px -8px var(--cyan);'
                                  " class="text-center rounded-circle"
                                style="padding: 1rem; width: 4rem; height: 4rem">
                                <i :class="clase.Tipo == 'documento'
                                  ? 'fa-file'
                                  : clase.Tipo == 'video'
                                    ? 'fa-play'
                                    : clase.Tipo == 'imagen'
                                      ? 'fa-image'
                                      : 'fa-icons'
                                  " class="fa-solid" style="font-size: 2rem"></i>
                              </div>
                            </div>
                            <!-- {{ clase }} -->
                            <div class="col-9 my-2 overflow-hidden my-3">
                              <h4 class="font-weight-bold text-capitalize">
                                {{ clase.Titulo }}
                              </h4>
                              <p class="text-white-50 m-0 custom-descripcion">
                                {{ clase.Descripcion }}
                              </p>
                              <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                                <i class="fas fa-circle-check mr-1"></i>
                                <small class="custom-punto d-flex align-items-center">
                                  última actualización
                                  <span class="ml-1 text-primary">
                                    {{
                                      clase.UltimaActualizacion
                                      | formatLastUpdateDate
                                    }}
                                  </span>
                                </small>
                                <i :class="clase.Tipo == 'documento'
                                  ? 'fa-file text-primary'
                                  : clase.Tipo == 'video'
                                    ? 'fa-play text-danger'
                                    : clase.Tipo == 'imagen'
                                      ? 'fa-image text-warning'
                                      : 'fa-icons text-purple'
                                  " class="fas mr-1"></i>
                                <small :class="clase.Tipo == 'documento'
                                  ? 'text-primary'
                                  : clase.Tipo == 'video'
                                    ? 'text-danger'
                                    : clase.Tipo == 'imagen'
                                      ? 'text-warning'
                                      : 'text-purple'
                                  ">{{
                                    clase.Tipo == "null" ? "Otros" : clase.Tipo
                                  }}</small>
                                <small class="d-flex justify-content-center align-items-center">
                                  <i style="font-size: 3px" class="fa-solid fa-circle px-2"></i>
                                </small>
                                <i class="fas fa-clock mr-1"></i>
                                <span class=" ">
                                  {{ clase.Duracion }} min
                                </span>
                                <!-- <span class=" "> {{formatTime(clase.Duracion)}} min </span> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
                  </div>
                </b-tab>
                <b-tab title="Listado de evaluaciones " @click="onResize">
                  <EvaluacionAcademia :idClase="clase.id" :habilitado="filterDataModalUpdateCurso.Habilitado" />
                </b-tab>
              </b-tabs>
            </b-collapse>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- agregar nueva clase modal -->
    <b-modal id="modalAgregarClase" title="Nueva Clase" size="md" hide-footer centere>
      <div class="row flex-column-reverse flex-lg-row">
        <div class="col">
          <b-form @submit.prevent="addClaseCursoAcademia">
            <div class="col-12 col-md">
              <!-- title -->
              <div class="mt-2">
                <b-form-group id="title" label-for="title">
                  <template #label>
                    <em class="text-danger font-weight-bold">Título: </em>
                  </template>
                  <b-form-input id="title" v-model="newClase.titulo" placeholder="Titulo de la clase"
                    required></b-form-input>
                </b-form-group>
              </div>
              <!-- descripcion -->
              <div class="mt-2">
                <b-form-group id="textarea" label-for="textarea">
                  <template #label>
                    <em class="text-danger font-weight-bold">Descripción: </em>
                  </template>
                  <b-form-textarea id="textarea" v-model="newClase.descripcion" placeholder="Descripcion de la clase..."
                    rows="3" max-rows="6" required></b-form-textarea>
                </b-form-group>
              </div>
              <div class="d-flex justify-content-end mt-2">
                <vs-button animation-type="scale" :loading="isLoading" danger size="large" style="min-width: 150px">
                  <i class="fas fa-circle-plus"></i>
                  <template #animate> Agregar clase</template>
                </vs-button>
              </div>
            </div>
          </b-form>
        </div>
        <!-- preview url video-->
      </div>
    </b-modal>
    <!-- update clase modal -->
    <b-modal id="modalUpdateClase" title="Actualizar Clase" size="md" hide-footer centered>
      <div class="row flex-column-reverse flex-lg-row">
        <div class="col">
          <b-form @submit.prevent="updateClaseCursoAcademia">
            <div class="col-12 col-md">
              <!-- title -->
              <div class="mt-2">
                <b-form-group id="title" label-for="title">
                  <template #label>
                    <em class="text-danger font-weight-bold">Título: </em>
                  </template>
                  <b-form-input id="title" v-model="filterDataModalUpdateClase.titulo" placeholder="Titulo de la clase"
                    required></b-form-input>
                </b-form-group>
              </div>
              <!-- descripcion -->
              <div class="mt-2">
                <b-form-group id="textarea" label-for="textarea">
                  <template #label>
                    <em class="text-danger font-weight-bold">Descripción: </em>
                  </template>
                  <b-form-textarea id="textarea" v-model="filterDataModalUpdateClase.descripcion"
                    placeholder="Descripcion de la clase..." rows="3" max-rows="6" required></b-form-textarea>
                </b-form-group>
              </div>
              <!-- duracion -->
              <!-- <div class="mt-2">
                  <b-form-group id="duration" label-for="duration">
                    <template #label>
                      <em class="text-danger font-weight-bold">Duración: </em>
                    </template>
                    <b-form-input id="duration" v-model="filterDataModalUpdateClase.duracion" type="number"
                      placeholder="Duración de la clase" required></b-form-input>
                  </b-form-group>
                </div> -->
              <!-- url video clase -->
              <!-- <b-form-group id="urlVideo" label-for="urlVideo">
                  <template #label>
                    <em class="text-danger font-weight-bold">URL video: </em>
                  </template>
                  <b-form-input type="url" id="urlVideo" v-model="filterDataModalUpdateClase.urlClaseVideo"
                    placeholder="URL de la clase" required></b-form-input>
                </b-form-group> -->
              <!-- btn submit -->
              <div class="d-flex justify-content-end mt-2">
                <vs-button animation-type="scale" :loading="isLoading" danger size="large" style="min-width: 150px">
                  <i class="fas fa-circle-check"></i>
                  <template #animate> Actualizar clase</template>
                </vs-button>
              </div>
            </div>
          </b-form>
        </div>
        <!-- preview url video-->
        <!-- <div class="col-12 mr-3 col-lg d-flex justify-content-center align-items-center bg-dark rounded mt-3 mt-lg-0">
            <div class="vista-previa d-flex justify-content-center align-items-center rounded">
              <h5>Vista previa</h5>
              <modalIframe :url="filterDataModalUpdateClase.urlClaseVideo" :likeElement="true"></modalIframe>
            </div>
          </div> -->
      </div>
    </b-modal>
    <!-- modal lista categoria -->
    <b-modal id="modalCategoria" title="Lista de categorias" size="md" hide-footer centered>
      <!-- {{ listaCategoriaCursos.data }} -->
      <div class="row align-items-center">
        <div class="col-12 col-lg-8">
          <b-form-input type="search" id="filterForTitle" placeholder="Filtrar clases por título"
            v-model="searchedTitleCategoria" required></b-form-input>
        </div>
        <div class="col d-flex mt-2 mt-lg-0 ml-xl-0 pl-xl-0">
          <vs-button @click="modalAgregarCategoria()" class="w-100" style="height: 40px">
            <i class="fas fa-circle-plus mr-1" style="font-size: 1.2rem"></i>
            Agregar categoria
          </vs-button>
        </div>
      </div>
      <div v-for="item of filterCategorias" :key="item.id" class="bg-dark p-2 rounded d-flex my-2 align-items-center">
        <!-- {{ item }} -->
        <div v-if="filterCategorias.length == 0" class="pb-5">
          <p class="h4">No hay clases para mostrar...</p>
        </div>
        <template v-else>

          <div v-if="item.Privacidad" class="rounded-circle d-flex align-items-center justify-content-center" style="
              box-shadow: 0 -1px 33px -8px rgb(19, 96, 238);
              -webkit-box-shadow: 0 -1px 33px -8px rgb(19, 96, 238);
              -moz-box-shadow: 0 -1px 33px -8px rgb(19, 96, 238);
              background-color: rgb(19, 96, 238);
              height: 2.5rem;
              width: 2.5rem;
            ">
            <i class="fa fa-lock" style="font-size: 1rem"></i>
          </div>
          <div v-else class="rounded-circle d-flex align-items-center justify-content-center" style="
              box-shadow: 0 -1px 33px -8px rgb(242, 19, 67);
              -webkit-box-shadow: 0 -1px 33px -8px rgb(242, 19, 67);
              -moz-box-shadow: 0 -1px 33px -8px rgb(242, 19, 67);
              background-color: rgb(242, 19, 67);
              height: 2.5rem;
              width: 2.5rem;
            ">
            <i class="fa fa-earth-americas" style="font-size: 1rem"></i>
          </div>

          <!-- <i class="fa-solid fa-icons"></i> -->
          <div class="ml-3">
            <b class="mb-0"> {{ item.Descripcion }}</b>
            <div class="d-flex">
              <span>Categoria</span>
              <b :class="item.Privacidad ? 'text-primary' : 'text-danger'" class="ml-1">{{ item.Privacidad ? "privada" :
                "Publica" }}</b>
            </div>
          </div>
          <b-dropdown v-if="item.Privacidad" class="ml-auto" style="top: 0; right: 0" size="sm" variant="link"
            toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <i class="fas fa-ellipsis" style="font-size: 1.5rem"></i>
            </template>
            <b-dropdown-item-button @click="updateCategoria(item)">
              <i class="fas fa-edit"></i> Editar
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="deleteCategoriaAcademia(item.Id)">
              <i class="fas fa-trash text-danger"></i>
              <span class="text-danger ml-1">Eliminar</span>
            </b-dropdown-item-button>
            <!-- <b-dropdown-item-button @click="deleteVideoClase(clase.id)">
                <i class="fas fa-trash text-danger"></i>
                <span class="text-danger ml-1">Eliminar</span>
              </b-dropdown-item-button> -->
          </b-dropdown>
        </template>
      </div>
      <!-- <div   
              >
            
            <div class="col-12 d-flex align-items-center py-2 bg-dark rounded"
                :style="{ transition: 'box-shadow 0.3s ease', boxShadow: activeCardVideoClase === index
                ? 'inset 0 0 0 2px #186bdd ' : 'none', cursor: 'default'}">
              <b-dropdown class="position-absolute" style="top: 0; right: 0" size="sm" variant="link"
                          toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fas fa-ellipsis" style="font-size: 1.5rem"></i>
                </template>
                <b-dropdown-item-button v-b-modal="'modalUpdateClase'">
                  <i class="fas fa-edit"></i> Editar
                </b-dropdown-item-button>
                <b-dropdown-item-button @click="deleteVideoClase(clase.id)">
                  <i class="fas fa-trash text-danger"></i>
                  <span class="text-danger ml-1">Eliminar</span>
                </b-dropdown-item-button>
              </b-dropdown>
              <div class="row w-100">
                <div class="col d-flex justify-content-center align-items-center">
                  <div class="p-2 p-lg-3 rounded-circle"
                      style="box-shadow: 0 -1px 33px -8px rgba(122,215,0,0.69); -webkit-box-shadow: 0 -1px 33px -8px rgba(122,215,0,0.69);
                    -moz-box-shadow: 0 -1px 33px -8px rgba(122,215,0,0.69); background-color: rgba(122,215,0,0.69)">
                    <i class="fa fa-book" style="font-size: 2rem"></i>
                  </div>
                </div>
                <div class="col-9 my-2 overflow-hidden my-3">
                  <h4 class="font-weight-bold text-capitalize">
                    {{ clase.titulo }}
                  </h4>
                  <p class="text-white-50 m-0 custom-descripcion">
                    {{ clase.descripcion }}
                  </p>
                  <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                    <i class="fas fa-circle-check mr-1"></i>
                    <small class="custom-punto d-flex align-items-center">
                      última actualización
                      <span class="ml-1 text-primary">
                      {{ clase.ultimaAcatualizacion | formatLastUpdateDate }}
                    </span>
                    </small>
                    <i class="fas fa-clock mr-1"></i>
                    <code class="text-white">{{ clase.duracion }}h</code>
                  </div>
                </div>
              </div>
            </div>
            <b-collapse :id="'collapse-' + index" :visible="activeCardVideoClase === index" class="mt-2">
              <div v-if="LoadingContenidos">
                <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
              </div>
              <div v-else>
                <div v-if="listaContenidoClases.length === 0">No hay contenidos aun cargados</div>
                <div v-else v-for="(clase, index) in filterContenidoClases" :key="clase.id"
                    @click="cardActiveClase(index)" class="col-12">
                  <div class="col-12 d-flex align-items-center py-2 bg-dark rounded"
                      :style="{ transition: 'box-shadow 0.3s ease', boxShadow: activeCardVideoClase === index
                        ? 'inset 0 0 0 2px #186bdd ' : 'none', cursor: 'default'}">
                    <b-dropdown class="position-absolute" style="top: 0; right: 0" size="sm" variant="link"
                                toggle-class="text-decoration-none" no-caret>
                      <template #button-content>
                        <i class="fas fa-ellipsis" style="font-size: 1.5rem"></i>
                      </template>
                      <b-dropdown-item-button v-b-modal="'modalUpdateClase'">
                        <i class="fas fa-edit"></i> Editar
                      </b-dropdown-item-button>
                      <b-dropdown-item-button @click="deleteVideoClase(clase.id)">
                        <i class="fas fa-trash text-danger"></i>
                        <span class="text-danger ml-1">Eliminar</span>
                      </b-dropdown-item-button>
                    </b-dropdown>
                    <div class="row w-100">
                      <div class="col d-flex justify-content-center align-items-center">
                        <div class="bg-secondary p-2 p-lg-3 rounded-circle"
                            style="box-shadow: 0 -1px 33px -8px #d70027; -webkit-box-shadow: 0 -1px 33px -8px #d70027;
                    -moz-box-shadow: 0 -1px 33px -8px #d70027;">
                          <i class="fa fa-book" style="font-size: 2rem"></i>
                        </div>
                      </div>
                      <div class="col-9 my-2 overflow-hidden my-3">
                        <h4 class="font-weight-bold text-capitalize">
                          {{ clase.Titulo }}
                        </h4>
                        <p class="text-white-50 m-0 custom-descripcion">
                          {{ clase.Descripcion }}
                        </p>
                        <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                          <i class="fas fa-circle-check mr-1"></i>
                          <small class="custom-punto d-flex align-items-center">
                            última actualización
                            <span class="ml-1 text-primary">
                              {{ clase.UltimaActualizacion | formatLastUpdateDate }}
                            </span>
                          </small>
                          <i class="fas fa-clock mr-1"></i>
                          <code class="text-white">{{ clase.Duracion }}h</code>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div> -->
    </b-modal>
    <!-- agregar nueva categoria modal -->
    <b-modal id="modalAgregarCategoria" title="Nueva Categoria" size="md" hide-footer centere @hidden="resetRow">
      <div class="row flex-column-reverse flex-lg-row">
        <div class="col">
          <b-form @submit.prevent="addCategoriaAcademia">
            <div class="col-12 col-md">
              <!-- title -->
              <div class="mt-2">
                <b-form-group id="title" label-for="title">
                  <template #label>
                    <em class="text-danger font-weight-bold">Nombre de la categoria:
                    </em>
                  </template>
                  <b-form-input id="title" v-model="row.Descripcion" placeholder="Titulo de la clase"
                    required></b-form-input>
                </b-form-group>
              </div>
              <!-- btn submit -->
              <div class="d-flex justify-content-end mt-2">
                <vs-button animation-type="scale" :loading="isLoading" danger size="large" style="min-width: 150px"
                  type="submit">
                  <i class="fas fa-circle-plus"></i>
                  <template #animate> Agregar Categoria</template>
                </vs-button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </b-modal>
    <!-- editar categoria modal -->
    <b-modal id="modalUpdateCategoria" title="Editar Categoria" size="md" hide-footer centere @hidden="resetRow">
      <div class="row flex-column-reverse flex-lg-row">
        <div class="col">
          <b-form @submit.prevent="UpdateCategoriaAcademia">
            <div class="col-12 col-md">
              <!-- title -->
              <div class="mt-2">
                <b-form-group id="title" label-for="title">
                  <template #label>
                    <em class="text-danger font-weight-bold">Nombre de la categoria:
                    </em>
                  </template>
                  <b-form-input id="title" v-model="row.Descripcion" placeholder="Titulo de la clase"
                    required></b-form-input>
                </b-form-group>
              </div>
              <!-- btn submit -->
              <div class="d-flex justify-content-end mt-2">
                <vs-button animation-type="scale" :loading="isLoading" danger size="large" style="min-width: 150px"
                  type="submit">
                  <i class="fas fa-circle-plus"></i>
                  <template #animate> Editar Categoria</template>
                </vs-button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </b-modal>
    <!------------------------------------------------- AGREGAR CONTENIDO MODAL ---------------------------------->
    <b-modal id="modalAgregarContenido" title="Nuevo Contenido" size="md" hide-footer centered no-close-on-esc
      no-close-on-backdrop>
      <!-- <h1>{{formatTime(duracion)}}</h1> -->
      <div class="row flex-column-reverse flex-lg-row">
        <div class="col">
          <b-form @submit.prevent="addContenido">
            <YouTubePlayer style="display: none !important" :videoId="inputUrl" />
            <div class="col-12 col-md">
              <!-- title -->
              <div class="mt-2">
                <b-form-group id="title" label-for="title">
                  <template #label>
                    <em class="text-danger font-weight-bold">Nombre del contenido:
                    </em>
                  </template>
                  <b-form-input id="title" v-model="rowContenido.Titulo" placeholder="Nombre del contenido"
                    required></b-form-input>
                </b-form-group>
              </div>
              <!-- Descripción -->
              <div class="mt-2">
                <b-form-group id="Description" label-for="Description">
                  <template #label>
                    <em class="text-danger font-weight-bold">Descripción: </em>
                  </template>
                  <b-form-input id="Description" v-model="rowContenido.Descripcion"
                    placeholder="Descripción del contenido" required></b-form-input>
                </b-form-group>
              </div>
              <!-- title -->
              <div class="mt-2">
                <b-form-group id="duration" label-for="duration">
                  <template #label>
                    <em class="text-danger font-weight-bold">Duración del contenido (minutos):
                    </em>
                  </template>
                  <b-form-input type="number" id="duration" v-model="rowContenido.Duracion"
                    placeholder="Duración del contenido"></b-form-input>
                </b-form-group>
              </div>
              <div class=" ">
                <vs-checkbox v-model="urlOpcion" @input="check">
                  <span class="mt-1">
                    Ingresar contenido a través de una url
                  </span>
                </vs-checkbox>
                <!-- <vs-switch v-model="urlOpcion"> </vs-switch> -->
              </div>
              <div v-show="urlOpcion" class="contenido">
                <div class="mt-2">
                  <b-form-group id="Description" label-for="Description">
                    <template #label>
                      <em class="text-danger font-weight-bold">URL contenido:
                      </em>
                    </template>
                    <b-form-input id="Description" v-model="inputUrl" placeholder="Url del video"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div v-show="urlOpcion == false">
                <!-- v3 -->
                <DropFile pathPut="" pathPost="ContenidoClasesCursosAcademia/CrearContenidoClaseCursoAcademia"
                  :fileTypes="[
                    'application/pdf',
                    'application/docx',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    'image/gif',
                    'application/msword',
                    'application/vnd.ms-excel',
                    'application/xlsx',
                    'application/vnd.ms-powerpoint',
                    'text/plain',
                    'image/*',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/vnd.ms-powerpoint',
                    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
                    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/vnd.ms-excel',
                    'application/xlsx',
                    'video/mp4',
                    'video/x-msvideo',
                    'video/x-matroska',
                    'video/quicktime',
                    'video/x-ms-wmv',
                    'video/webm',
                    'video/3gpp',
                    'video/3gpp2',
                  ]" />
              </div>
              <!-- btn submit -->
              <div class="d-flex justify-content-end mt-2">
                <vs-button animation-type="scale" :loading="isLoading" danger size="large" style="min-width: 150px"
                  type="submit">
                  <i class="fas fa-circle-plus"></i>
                  <template #animate>Agregar Contenido</template>
                </vs-button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </b-modal>
    <!------------------------------------------------- EDITAR CONTENIDO MODAL ---------------------------------->
    <b-modal id="modalEditarContenido" title="Editar Contenido" size="xl" hide-footer centered no-close-on-esc
      no-close-on-backdrop>
      <div class="row flex-column-reverse flex-lg-row">
        <!------------------------------------------------------------------ #endregion PREVISUALIZACIÓN DEL CONTENIDO ------------------------------------------------------------------>
        <div class="col-lg-6 d-flex align-items-center justify-content-center">
          <!------------------------------------------------------------------ #region Contenido Externo ------------------------------------------------------------->

          <div v-if="
            rowContenido.Tipo === 'video' &&
            rowContenido?.UrlContenidoCurso?.includes('youtube')
          " :style="rowContenido.UrlContenidoCurso &&
            rowContenido.UrlContenidoCurso.length === 11
            ? ''
            : 'display:none !important'
            " class="video-container-yt">
            <YouTubePlayer class="rounded responsive-iframe-yt" :videoId="inputUrl" />
          </div>

          <ContenidoHelexium :fileId="rowContenido.UrlContenidoCurso" style="height: 500px; width: 100%" />
          <!------------------------------------------------------------------ #endregion Contenido Externo ------------------------------------------------------------->

          <!------------------------------------------------------------------ #region iMAGEN --------------------------------------------------------------------------->
          <div class="bg-dark p-3 rounded" v-if="rowContenido.Tipo == 'imagen'">
            <ContenidoHelexium :fileId="rowContenido.UrlContenidoCurso" :BotonDescargarArchivos="false" />
          </div>
          <!------------------------------------------------------------------ #endregion Contenido Externo ------------------------------------------------------------->
          <div v-if="
            rowContenido.Tipo != 'imagen' &&
            rowContenido.Tipo != 'documento' &&
            rowContenido.Tipo != 'video' &&
            !previewUrl
          " class="bg-dark rounded">
            <p class="text-center justify-content-center">
              No se ha encontrado vista preliminar
            </p>
          </div>

          <!-- <iframe class="rounded"
            v-if="rowContenido.UrlContenidoCurso != null && rowContenido.UrlContenidoCurso.includes('youtube') && !rowContenido.UrlContenidoCurso.includes('watch?v=')"
            width="560" height="315" :src="rowContenido.UrlContenidoCurso" frameborder="0" allowfullscreen></iframe> -->
          <div v-if="
            rowContenido?.UrlContenidoCurso?.includes('youtube') &&
            rowContenido?.UrlContenidoCurso?.includes('watch?v=') &&
            !rowContenido?.UrlContenidoCurso?.includes('ted.com') &&
            !rowContenido?.UrlContenidoCurso?.includes('vimeo.com') &&
            !rowContenido?.UrlContenidoCurso?.includes('loom.com')
          " class="bg-dark d-flex justify-content-center align-items-center"
            style="width: 100%; height: 100%; color: white">
            No se ha detectado la vista previa
          </div>
        </div>
        <!------------------------------------------------------------------ #endregion PREVISUALIZACIÓN DEL CONTENIDO ------------------------------------------------------------------>
        <div class="col">
          <b-form @submit.prevent="UpdateContenidoAcademia">
            <div class="col-12 col-md">
              <!-- title -->
              <div class="mt-2">
                <b-form-group id="title" label-for="title">
                  <template #label>
                    <em class="text-danger font-weight-bold">Nombre del contenido:
                    </em>
                  </template>
                  <b-form-input id="title" v-model="rowContenido.Titulo" placeholder="Titulo del contenido"
                    :disabled="filterDataModalUpdateCurso.Habilitado" required></b-form-input>
                </b-form-group>
              </div>
              <!-- Descripción -->
              <div class="mt-2">
                <b-form-group id="Description" label-for="Description">
                  <template #label>
                    <em class="text-danger font-weight-bold">Descripción:</em>
                  </template>
                  <b-form-input id="Description" v-model="rowContenido.Descripcion"
                    :disabled="filterDataModalUpdateCurso.Habilitado" placeholder="Descripción del contenido"
                    required></b-form-input>
                </b-form-group>
              </div>
              <div class="mt-2">
                <b-form-group id="duration" label-for="duration">
                  <template #label>
                    <em class="text-danger font-weight-bold">Duración del contenido (minutos):
                    </em>
                  </template>
                  <b-form-input type="number" id="duration" v-model="rowContenido.Duracion"
                    placeholder="Duración del contenido" :disabled="filterDataModalUpdateCurso.Habilitado"
                    required></b-form-input>
                </b-form-group>
              </div>
              <div class=" ">
                <vs-checkbox v-model="urlOpcion" @input="check" v-if="!filterDataModalUpdateCurso.Habilitado">
                  <span class="mt-1">
                    Ingresar contenido a través de una url
                  </span>
                </vs-checkbox>
              </div>
              <div v-show="urlOpcion" class="contenido">
                <!-- Video -->
                <div class="mt-2">
                  <b-form-group id="Description" label-for="Description">
                    <template #label>
                      <em class="text-danger font-weight-bold">URL contenido:
                      </em>
                    </template>
                    <b-form-input id="Description" v-model="inputUrl" :disabled="filterDataModalUpdateCurso.Habilitado"
                      placeholder="Url del video"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div v-show="urlOpcion == false">
                <DropFile pathPost="ContenidoClasesCursosAcademia/CrearContenidoClaseCursoAcademia"
                  v-if="!filterDataModalUpdateCurso.Habilitado"
                  :pathPut="'ContenidoClasesCursosAcademia/ActualizarContenido/'" :fileTypes="[
                    'application/pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/vnd.ms-powerpoint',
                    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
                    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
                    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
                    'application/docx',
                    'application/xlsx',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    'image/gif',
                    'image/*',
                    'text/plain',
                    'video/mp4',
                    'video/x-msvideo',
                    'video/x-matroska',
                    'video/quicktime',
                    'video/x-ms-wmv',
                    'video/webm',
                    'video/3gpp',
                    'video/3gpp2',
                  ]" />
              </div>
              <!-- btn submit -->
              <div class="d-flex justify-content-end mt-2">
                <vs-button animation-type="scale" :loading="isLoading" danger size="large" style="min-width: 150px"
                  type="submit" v-if="!filterDataModalUpdateCurso.Habilitado">
                  <i class="fas fa-circle-plus"></i>
                  <template #animate>Actualizar Contenido</template>
                </vs-button>
              </div>
            </div>
          </b-form>
          <!-- <p>------ {{videoDurationYT}}</p> -->
        </div>
      </div>
    </b-modal>
    <!-- modal seguimiento cursos -->
    <b-modal v-model="VisibleSeguimiento" title="Iniciar seguimiento de curso personas" size="lg" hide-footer centered>
      <DataTableLotes :columns="columnsSeguimiento" ref="dataTableLotesSeguimiento" :busqueda-boton="true"
        :fetch-data="fetchDataSeguimiento" :seleccion-multiple="true" keySeleccion="PersonaId"
        @KeySelection="PersonasSeleccionadasInicioCurso = $event" />
      <div style="display: flex">
        <vs-button :disabled="PersonasSeleccionadasInicioCurso.length === 0" @click="IniciarSeguimientoPersonas"
          :loading="BotonCargaAgregarPersonas">Agregar Al curso
        </vs-button>
        <vs-button :disabled="cursoSeguimientoId === ''" @click="CargaMasivaVisible = true" warn>
          Carga Masiva
        </vs-button>
      </div>
    </b-modal>

    <b-modal v-model="CargaMasivaVisible" title="Carga masiva" hide-footer centered @hidden="limpiarDatosExcel">
      <DropFileBasic ref="DropFileBasic" @handleFileData="handleFileUpload" @change="handleFileUpload" :fileTypes="[
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ]" />
      <div style="display: flex">
        <vs-button success @click="descargarFormatoExcel">
          Descargar Formato
        </vs-button>

        <vs-button :disabled="DocumentosMasivos.length === 0" warn @click="traerIdPersonasMasivas"
          :loading="BotonCargaAgregarPersonas">Cargar Personas
        </vs-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import YouTubePlayer from "@/components/helexium/YouTubePlayer.vue";
import EvaluacionAcademia from "@/components/helexium/EvaluacionAcademia.vue";
import DropFile from "@/components/helexium/DropFileContenidoAcademia.vue";
import { eventBus } from "../../../../main";
import Vue from "vue";
import vSelect from "vue-select";
import moment_timezone from "moment-timezone";
import DataTableLotes from "@/components/Datatable/DataTableLotes.vue";
import DropFileBasic from "@/components/helexium/DropFileBasic.vue";
import * as XLSX from "xlsx";
import ContenidoHelexium from "@/components/helexium/ContenidoHelexium.vue";


Vue.component("v-select", vSelect);
const Swal = require("sweetalert2");
export default {
  name: "Academia_component",
  components: {
    DropFileBasic,
    DropFile,
    DataTableLotes,
    EvaluacionAcademia,
    YouTubePlayer,
    ContenidoHelexium,
  },
  data() {
    return {
      inputUrl: "",
      videoUrl: "",
      previewUrl: "",
      // videoUrl: "",
      // embedUrl: "",
      // durationVideo: "",
      videoDurationYT: 0,
      duracion: 0,
      IndexEvaluaciones: null,
      cursoId: null,
      loadingStates: {},
      urlOpcion: false,
      contenidoClaseServicio: [],
      rowContenido: {},
      row: {},
      categoriasItem: [
        { id: 1, descripcion: "test categoria" },
        { id: 2, descripcion: "test categoria" },
        { id: 3, descripcion: "test categoria" },
        { id: 4, descripcion: "test categoria" },
        { id: 5, descripcion: "test categoria" },
        { id: 6, descripcion: "test categoria" },
        { id: 7, descripcion: "test categoria" },
      ],
      persona: {},
      newCourse: {
        titulo: "",
        descripcion: "",
        previewImagenUrl: "",
        categoriaCursoId: "",
        certificadoFinalizacion: null,
        Privacidad: true,
        responsableId: null,
        ultimaActualizacion: "",
        notaMinima: null,
        notaMaxima: null,
        InscripcionPublica: false,
      },
      newClase: {
        titulo: "",
        descripcion: "",
        // duracion: "",
        urlClaseVideo: "",
        cursoAcademiaId: null,
        ultimaAcatualizacion: "",
        responsableId: null,
      },

      listaCursosAcademia: [],
      listaVideosClases: [],
      listaContenidoClases: [],

      showReadMoreDesc: {},
      listaCategoriaCursos: [],
      optionsCertificacion: [
        {
          text: "Si incluye certificación",
          value: 1,
        },
        {
          text: "No incluye certificación",
          value: 2,
        },
      ],
      optionsPrivacidadCursos: [
        {
          text: "Privado (Solo tu empresa podrá ver este curso)",
          value: true,
          icon: "lock",
        },
        {
          text: "Público (Todas las empresas podrán ver este curso)",
          value: false,
          icon: "earth-americas",
        },
      ],
      active: false,
      isLoading: false,
      imagePreview: null,
      file: null,
      fileName: null,
      searchedTitleCursos: "",
      searchedTitleClase: "",
      searchedTitleCategoria: "",
      activeCardVideoCursos: null,
      activeCardVideoClase: null,
      filterDataModalUpdateCurso: {},
      filterDataModalUpdateClase: {
        id: null,
        titulo: "",
        descripcion: "",
        // duracion: "",
        urlClaseVideo: "",
        cursoAcademiaId: null,
        ultimaAcatualizacion: "",
        responsableId: null,
        responsable: {},
        cursoAcademia: {},
      },

      LoadingCursos: false,
      LoadingContenidos: false,
      ActiveClase: 0,
      activeTab: 0,

      clases: [],
      EmpresaId: "",
      CargaMasivaVisible: false,

      //Administracion Seguimiento
      columns: [
        { label: "Cedula", key: "Cedula", sortable: true, width: "100px" },
        {
          label: "Nombre",
          key: "NombreCompleto",
          sortable: true,
          width: "100px",
        },
        { label: "Curso", key: "CursoNombre", sortable: true, width: "100px" },
        { label: "Estado", key: "Completado", sortable: true, width: "100px" },
        {
          label: "Fecha inicio",
          key: "FechaInicio",
          sortable: true,
          width: "100px",
        },
        {
          label: "Fecha Finalización",
          key: "FechaFinalizacion",
          sortable: true,
          width: "100px",
        },
        {
          label: "Nota del Usuario",
          key: "NotaFinal",
          sortable: true,
          width: "100px",
        },
        { label: "Opciones", key: "Id", sortable: false, width: "100px" },
      ],
      columnsSeguimiento: [
        {
          label: "Nombre",
          key: "NombreCompleto",
          sortable: true,
          width: "100px",
        },
        { label: "Cedula", key: "Cedula", sortable: true, width: "100px" },
      ],
      cursoSeguimientoId: "",
      ListaCursosSelect: [],
      NotasCurso: [],
      fechaActual: this.$moment()
        .tz("America/Bogota")
        .format("YYYY-MM-DDTHH:mm"),
      personaSelect: null,
      VisibleSeguimiento: false,
      PersonasSeleccionadasInicioCurso: [],
      BotonCargaAgregarPersonas: false,
      datosSeguimiento: [],
      headersExportacion: [
        { key: 'Cedula', header: 'Cédula' },
        { key: 'NombreCompleto', header: 'Nombre Completo' },
        { key: 'CursoNombre', header: 'Curso' },
        { key: 'Completado', header: 'Estado' },
        { key: 'FechaInicio', header: 'Fecha Inicio' },
        { key: 'FechaFinalizacion', header: 'Fecha Finalización' },
        { key: 'NotaFinal', header: 'Nota Final' }
      ],

      //Carga Retrasada Cursos edit
      CantidadDatos: 6,
      Paginacion: 1,
      hasMore: true,
      isLoadingCurso: false,
      DocumentosMasivos: [],
    };
  },
  watch: {
    inputUrl(newValue, oldValue) {
      console.log(`El valor del input cambió de "${oldValue}" a "${newValue}"`);
      if (this.inputUrl.includes("docs.google")) {
        console.log("Url sin convertir detectada ----------");
        this.rowContenido.Tipo = "documento";
        console.log("Tipo ----------", this.rowContenido.Tipo);
        this.rowContenido.UrlContenidoCurso = this.inputUrl;
      }
      if (this.inputUrl.includes("loom.com")) {
        console.log("Url sin convertir detectada ----------");
        this.rowContenido.Tipo = "video";
        console.log("Tipo ----------", this.rowContenido.Tipo);
        this.rowContenido.UrlContenidoCurso = this.convertToEmbedUrl(
          this.inputUrl
        );
      }
      if (this.inputUrl.includes("vimeo.com")) {
        console.log("Url sin convertir detectada ----------");
        this.rowContenido.Tipo = "video";
        console.log("Tipo ----------", this.rowContenido.Tipo);
        this.rowContenido.UrlContenidoCurso = this.convertToEmbedUrl(
          this.inputUrl
        );
      }
      if (this.inputUrl.includes("ted.com")) {
        console.log("Url sin convertir detectada ----------");
        this.rowContenido.Tipo = "video";
        console.log("Tipo ----------", this.rowContenido.Tipo);
        this.rowContenido.UrlContenidoCurso = this.convertToEmbedUrl(
          this.inputUrl
        );
      }
      if (
        !this.inputUrl.includes("ted.com") &&
        !this.inputUrl.includes("vimeo.com") &&
        !this.inputUrl.includes("loom.com") &&
        !this.inputUrl.includes("helexiumfiles.com")
      ) {
        if (this.videoDurationYT != 0 || this.videoDurationYT != null) {
          this.rowContenido.Duracion = this.videoDurationYT;
        }
      }
    },
  },
  async mounted() {
    this.actualizarOpciones();
    eventBus.$on("videoDurationYT", (minutes) => {
      this.videoDurationYT = minutes;
      console.log(
        "Duración recibida en el componente padre:",
        this.videoDurationYT
      );
    });

    eventBus.$on("videoDuration", async (duration) => {
      this.duracion = duration;
    });
    eventBus.$on("onUploadAcademy", async (respuesta, mensaje) => {
      try {
        console.log("dateSend academia", respuesta, "--", mensaje);
        if (respuesta) {
          console.log("dataSend 1");
          this.$vs.notification({
            // duration: "none",
            progress: "auto",
            icon: `<i class='fas fa-circle-check'></i>`,
            color: "primary",
            position: "top-right",
            title: mensaje,
          });
          await this.cardActiveClase(this.ActiveClase);
          this.$bvModal.hide("modalAgregarContenido");
          // this.$bvModal.hide('modalEditarContenido');
        } else {
          console.log("dataSend 2");
          this.$vs.notification({
            // duration: "none",
            progress: "auto",
            icon: `<i class='fas fa-xmark'></i>`,
            color: "danger",
            position: "top-right",
            title: mensaje,
          });
        }
      } catch (error) {
        console.log("error on", error);
      }
    });
    const valor = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.EmpresaId = valor.empresa.id;
    // this.ContenidoClase();
    this.getCategoriasCursos();
    this.getListCursosAcademia();
    window.addEventListener("resize", this.onResize);
  },
  created() {
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    eventBus.$off("onUploadAcademy");
    eventBus.$off("videoDuration");
    eventBus.$off("videoDurationYT");
  },
  methods: {
    async detectContentType(url) {
      try {
        const response = await fetch(url, { method: "HEAD" });
        const type = response.headers.get("Content-Type");
        return type || "desconocido";
      } catch (e) {
        console.error(e);
        return "error";
      }
    },
    actualizarOpciones() {
      if (this.persona.rol.nivel === 4) {
        this.optionsPrivacidadCursos = [
          {
            text: "Privado (Solo tu empresa podrá ver este curso)",
            value: true,
            icon: "lock",
          },
          {
            text: "Público (Todas las empresas podrán ver este curso)",
            value: false,
            icon: "earth-americas",
          },
        ];
      } else {
        this.optionsPrivacidadCursos = [
          {
            text: "Privado (Solo tu empresa podrá ver este curso)",
            value: true,
            icon: "lock",
          },
        ];
      }
    },
    modalCategoria() {
      this.searchedTitleCategoria = "";
      this.$bvModal.show("modalCategoria");
    },

    convertToEmbedUrl(Url) {
      if (this.inputUrl.includes("loom")) {
        const videoId = Url.split("/").pop().split("?")[0];
        console.log("Url convertida ----------");
        return `https://www.loom.com/embed/${videoId}`;
      }
      if (this.inputUrl.includes("vimeo")) {
        const videoId = Url.split("/").pop().split("?")[0];
        console.log("Url convertida ----------");
        return `https://player.vimeo.com/video/${videoId}`;
      }
      if (this.inputUrl.includes("ted.com")) {
        const videoId = Url.split("/").pop();
        console.log("Url convertida ----------");
        return `https://embed.ted.com/talks/${videoId}`;
      }
    },
    modalUpdateCurso(curso) {
      this.$bvModal.show("modalUpdateCurso");
      console.log(" ln-1630 ---------- ", curso);
      this.filterDataModalUpdateCurso = curso;
      // this.urlOpcion = false,
      //   } else {
      //     this.listaContenidoClases = [];
      //   }
      // });
      // this.$set(this.loadingStates, index, false);
      //   setTimeout(() => {
      //   this.$set(this.loadingStates, index, false);
      // }, 2000);
    },
    check() {
      if (!this.urlOpcion) {
        this.inputUrl = "";
      }
    },
    modalEditarContenido(item) {
      // console.log('modaleditar contenido--------',item)
      (this.videoDurationYT = 0),
        (this.duracion = 0),
        (this.urlOpcion = false),
        // this.inputUrl = this.rowContenido.UrlContenidoCurso
        (this.rowContenido = { ...item });

      console.log(
        //"[modalEditarContenido] la url del contenido es: ",
        this.rowContenido.UrlContenidoCurso
      );

      this.urlOpcion =
        this.rowContenido.UrlContenidoCurso != null &&
          this.rowContenido.UrlContenidoCurso.includes("https:")
          ? true
          : false;
      this.inputUrl =
        this.rowContenido.UrlContenidoCurso != null &&
          this.rowContenido.UrlContenidoCurso.includes("https:")
          ? this.rowContenido.UrlContenidoCurso
          : "";
      // console.log('modaleditar contenido--------',this.rowContenido)
      // console.log('ln-1690-----' , this.rowContenido.UrlContenidoCurso)
      // console.log('ln-1199', this.rowContenido)
      // alert(this.row.Descripcion)
      this.$bvModal.show("modalEditarContenido");
    },
    async deleteContenidoAcademia(id) {
      Swal.fire({
        title: "¿Seguro que deseas eliminar este contenido?",
        text: "Después de eliminarlo no podrás recuperarlo.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#186bdd",
        cancelButtonColor: "#F2135D",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            var contenido = this.listaContenidoClases.find((x) => x.ID == id);
            this.clases[this.activeCardVideoClase].duracion -=
              contenido.Duracion;
            let res = await this.$store.dispatch("hl_delete", {
              path: "ContenidoClasesCursosAcademia/EliminarContenido/" + id,
            });

            this.cardActiveClase(this.ActiveClase);
            if (res.respuesta) {
              this.$vs.notification({
                progress: "auto",
                icon: `<i class='fas fa-circle-check'></i>`,
                color: "primary",
                position: "top-right",
                title: res.mensaje,
              });
            } else {
              this.$vs.notification({
                progress: "auto",
                icon: `<i class='fas fa-xmark'></i>`,
                color: "danger",
                position: "top-right",
                title: res.mensaje,
              });
            }
          } catch (error) {
            console.log("Error:", error);
            this.$vs.notification({
              progress: "auto",
              icon: `<i class='fas fa-xmark'></i>`,
              color: "danger",
              position: "top-right",
              title: "Ha ocurrido un error!",
              text: error,
            });
          }
        }
      });
    },
    async UpdateContenidoAcademia() {
      try {
        if (this.inputUrl != "") {
          console.log(
            "[UpdateContenidoAcademia] El inputUrl es:",
            this.inputUrl
          );
          this.rowContenido.UrlContenidoCurso = this.inputUrl;
        }

        console.log(
          "[UpdateContenidoAcademia] La url del contenido es",
          this.rowContenido.UrlContenidoCurso
        );

        // Validación de URL si está usando la opción de URL
        if (this.urlOpcion) {
          const urlsValidas = [
            "youtube.com",
            "youtu.be",
            "canva.com",
            "ted.com",
            "vimeo.com",
            "loom.com",
            "helexiumfiles.com",
            "docs.google",
            "http://127.0.0.1:44388/",
            "https://bupewebprodapi.azurewebsites.net/",
          ];

          const esUrlValida = urlsValidas.some((url) =>
            this.inputUrl.includes(url)
          );

          if (!esUrlValida) {
            this.$vs.notification({
              progress: "auto",
              icon: `<i class='fas fa-xmark'></i>`,
              color: "danger",
              position: "top-right",
              title:
                "La URL ingresada no es válida. Por favor ingrese una URL de YouTube, Vimeo, Loom, Ted, Canva, Google Docs o Helexium.",
            });
            return;
          }
        }

        // Procesar YouTube
        if (
          this.inputUrl.includes("youtube.com") ||
          this.inputUrl.includes("youtu.be")
        ) {
          this.rowContenido.Tipo = "video";
          let videoId = null;

          try {
            const urlObj = new URL(this.rowContenido.UrlContenidoCurso);
            const params = new URLSearchParams(urlObj.search);

            if (params.has("v")) {
              videoId = params.get("v");
            } else if (
              urlObj.pathname.includes("youtu.be") ||
              urlObj.hostname === "youtu.be"
            ) {
              videoId = urlObj.pathname.split("/")[1];
            }

            if (videoId && videoId.length === 11) {
              this.rowContenido.UrlContenidoCurso = videoId;
            } else {
              throw new Error("ID inválido");
            }

            if (this.videoDurationYT != 0 && this.videoDurationYT != null) {
              this.rowContenido.Duracion = this.videoDurationYT;
              console.log(
                "[UpdateContenidoAcademia] Nueva duración de YouTube:",
                this.videoDurationYT
              );
            }
          } catch (error) {
            console.error(error);
            this.$vs.notification({
              progress: "auto",
              icon: `<i class='fas fa-xmark'></i>`,
              color: "danger",
              position: "top-right",
              title: "No se pudo extraer el ID del video de YouTube!",
            });
            return;
          }
        }

        // Procesar Canva
        if (this.inputUrl.includes("canva.com")) {
          let url = new URL(this.inputUrl);
          let parts = url.pathname.split("/");

          if (parts.includes("edit")) {
            parts[parts.indexOf("edit")] = "view";
          } else if (parts.includes("watch")) {
            parts[parts.indexOf("watch")] = "view";
          }

          url.pathname = parts.join("/");
          url.search = "embed";

          this.rowContenido.Tipo = "documento";
          this.inputUrl = url.toString();

          console.log("Tipo ----------", this.rowContenido.Tipo);
          console.log("CONVERTIDO CANVA ----------", this.inputUrl);
        }

        // Procesar Loom
        if (this.inputUrl.includes("loom.com")) {
          this.rowContenido.Tipo = "video";
          this.rowContenido.UrlContenidoCurso = this.convertToEmbedUrl(
            this.inputUrl
          );
        }

        // Procesar Vimeo
        if (this.inputUrl.includes("vimeo.com")) {
          this.rowContenido.Tipo = "video";
          this.rowContenido.UrlContenidoCurso = this.convertToEmbedUrl(
            this.inputUrl
          );
        }

        // Procesar TED
        if (this.inputUrl.includes("ted.com")) {
          this.rowContenido.Tipo = "video";
          this.rowContenido.UrlContenidoCurso = this.convertToEmbedUrl(
            this.inputUrl
          );
        }

        // Procesar Google Docs
        if (this.inputUrl.includes("docs.google")) {
          this.rowContenido.Tipo = "documento";
        }

        Swal.fire({
          title: "Procesando contenido",
          text: "El contenido está siendo procesado, esto puede tardar unos minutos.",
          icon: "info",
          confirmButtonColor: "#186bdd",
          confirmButtonText: "¡Entendido!",
        });

        // Guardar el contenido
        await new Promise((resolve, reject) => {
          eventBus.$emit(
            "GuardandoContenidoCurso",
            { resolve, reject },
            `cursosAcademia/${this.persona.empresa.nombre.replace(
              /\s/g,
              ""
            )} - ${this.persona.empresa.id
            }/${this.filterDataModalUpdateCurso.titulo.replace(/\s/g, "")} - ${this.filterDataModalUpdateCurso.id
            }/${this.rowContenido.Titulo.replace(/\s/g, "")} - ${this.rowContenido.ClasesCursosAcademiaId
            }`,
            this.rowContenido
          );
        });
        await this.getInfoClasesCursoAcademia(this.cursoId);

      } catch (error) {
        console.error("[UpdateContenidoAcademia] Error:", error);
        this.$vs.notification({
          progress: "auto",
          icon: `<i class='fas fa-xmark'></i>`,
          color: "danger",
          position: "top-right",
          title: "Error al actualizar el contenido",
          text: error.message,
        });
      }

      this.$bvModal.hide("modalEditarContenido");
    },
    modalAgregarContenido(item) {
      this.rowContenido.ID = undefined;

      (this.videoDurationYT = 0),
        (this.urlOpcion = false),
        (this.inputUrl = "");
      this.rowContenido.UrlContenidoCurso = "";
      this.rowContenido.ClasesCursosAcademiaId = item.id;
      this.rowContenido.Descripcion = "";
      this.rowContenido.Duracion = "";
      this.rowContenido.Titulo = "";
      // this.rowContenido.Duracion = ''
      this.duracion = 0;
      this.rowContenido.UrlContenidoCurso = this.inputUrl;
      this.$forceUpdate();
      this.$bvModal.show("modalAgregarContenido");

      console.log("ln-1147----", item);
      // alert(this.row.Descripcion)
      console.log("ln-1399--", this.rowContenido.Descripcion);
    },
    async addContenido() {
      try {
        console.log("entro");
        this.rowContenido.ResponsableId = this.persona.id;
        const type = await this.detectContentType(this.inputUrl);
        console.log("Tipo real:", type);
        this.isLoading = true;
        // this.rowContenido.Duracion = 10
        if (this.duracion != 0 && this.duracion != "noVideo") {
          this.rowContenido.Duracion = this.duracion;
        }

        console.log(this.inputUrl, "------this.inputUrl");
        if (this.inputUrl.includes("youtube.com")) {
          this.rowContenido.Tipo = "video";
          console.log("Tipo ----------", this.rowContenido.Tipo);
          let videoId = null;
          console.log("viedoID----", videoId);
          try {
            const urlObj = new URL(this.inputUrl);
            const params = new URLSearchParams(urlObj.search);
            if (params.has("v")) {
              console.log("---aqui");

              videoId = params.get("v");
            } else if (urlObj.pathname.includes("youtu.be")) {
              videoId = urlObj.pathname.split("/")[1];
              console.log("---aqui");
            }

            if (videoId && videoId.length === 11) {
              this.inputUrl = videoId;
              console.log("viedoID----", videoId);

              console.log("---aqui");
            } else {
              throw new Error("ID inválido");
            }
            if (this.videoDurationYT != 0 || this.videoDurationYT != null) {
              console.log("Duración del video:", this.videoDurationYT);
              this.rowContenido.Duracion = this.videoDurationYT;
            }
          } catch (error) {
            console.log(error);
            this.$vs.notification({
              progress: "auto",
              icon: `<i class='fas fa-xmark'></i>`,
              color: "danger",
              position: "top-right",
              title: "No se pudo extraer el ID del video!",
            });
            return;
          }
        }
        if (this.inputUrl.includes("canva.com")) {
          // Quitamos cualquier /edit? o /watch? y lo cambiamos a /view?embed
          let url = new URL(this.inputUrl);
          let parts = url.pathname.split("/");

          // Ejemplo: /design/DAF.../edit  →  /design/DAF.../view
          if (parts.includes("edit")) {
            parts[parts.indexOf("edit")] = "view";
          } else if (parts.includes("watch")) {
            parts[parts.indexOf("watch")] = "view";
          }

          url.pathname = parts.join("/");
          url.search = "embed"; // agregamos ?embed

          this.rowContenido.Tipo = "documento";
          console.log("Tipo ----------", this.rowContenido.Tipo);

          console.log("CONVERTIDO CANVA ----------", url.toString());

          this.inputUrl = url.toString();
        }
        if (this.inputUrl.includes("loom.com")) {
          console.log("Url sin convertir detectada ----------");
          this.rowContenido.Tipo = "video";
          console.log("Tipo ----------", this.rowContenido.Tipo);
          this.inputUrl = this.convertToEmbedUrl(this.inputUrl);
        }
        if (this.inputUrl.includes("vimeo.com")) {
          console.log("Url sin convertir detectada ----------");
          this.rowContenido.Tipo = "video";
          console.log("Tipo ----------", this.rowContenido.Tipo);
          this.inputUrl = this.convertToEmbedUrl(this.inputUrl);
        }
        if (this.inputUrl.includes("ted.com")) {
          console.log("Url sin convertir detectada ----------");
          this.rowContenido.Tipo = "video";
          console.log("Tipo ----------", this.rowContenido.Tipo);

          this.inputUrl = this.convertToEmbedUrl(this.inputUrl);
        }
        console.log(
          "url video ----------",
          this.rowContenido.UrlContenidoCurso
        );

        this.rowContenido.UrlContenidoCurso = this.inputUrl;

        //console.log('[addContenido] el rowContenido es: ', this.rowContenido);

        await new Promise((resolve, reject) => {
          eventBus.$emit(
            "GuardandoContenidoCurso",
            { resolve, reject }, // este es el "ack"
            `cursosAcademia/${this.persona.empresa.nombre.replace(
              /\s/g,
              ""
            )} - ${this.persona.empresa.id
            }/${this.filterDataModalUpdateCurso.titulo.replace(/\s/g, "")} - ${this.filterDataModalUpdateCurso.id
            }/${this.rowContenido.Titulo.replace(/\s/g, "")} - ${this.rowContenido.ClasesCursosAcademiaId
            }`,
            this.rowContenido
          );
        });

        await this.getInfoClasesCursoAcademia(this.cursoId);

      } catch (error) {
        console.log("---error ln-2117------", error);
      } finally {
        this.isLoading = false;
      }
    },
    modalAgregarCategoria() {
      this.row.Descripcion = "";
      this.$bvModal.show("modalAgregarCategoria");
    },
    async addCategoriaAcademia() {
      this.row.Privacidad = true;
      this.row.EmpresaId = this.persona.empresa.id;
      console.log("[addCategoriaAcademia] La información a registrar es:", this.row);

      let res = await this.$store.dispatch("hl_post", {
        path: "CategoriasCursos/CrearCategoriaCurso/",
        data: this.row,
      });
      console.log("ln-1725 -----", res);
      this.$bvModal.hide("modalAgregarCategoria");

      this.getCategoriasCursos();
      if (res.respuesta) {
        this.$vs.notification({
          // duration: "none",
          progress: "auto",
          icon: `<i class='fas fa-circle-check'></i>`,
          color: "primary",
          position: "top-right",
          title: res.mensaje,
        });
      } else {
        this.$vs.notification({
          // duration: "none",
          progress: "auto",
          icon: `<i class='fas fa-xmark'></i>`,
          color: "danger",
          position: "top-right",
          title: res.mensaje,
        });
      }
      this.row.Descripcion = "";
    },
    updateCategoria(item) {
      this.row = { ...item };

      // alert(this.row.Descripcion)
      this.$bvModal.show("modalUpdateCategoria");
    },
    async UpdateCategoriaAcademia() {
      let id = this.row.Id;
      let dataRow = { ...this.row };
      delete dataRow.id;
      let res = await this.$store.dispatch("hl_post", {
        path: "CategoriasCursos/ActualizarCategoriaCurso/" + id,
        data: dataRow,
      });

      console.log("ln-1837 -----", res);
      this.$bvModal.hide("modalUpdateCategoria");

      this.getCategoriasCursos();

      if (res.respuesta) {
        this.$vs.notification({
          // duration: "none",
          progress: "auto",
          icon: `<i class='fas fa-circle-check'></i>`,
          color: "primary",
          position: "top-right",
          title: res.mensaje,
        });
      } else {
        this.$vs.notification({
          // duration: "none",
          progress: "auto",
          icon: `<i class='fas fa-xmark'></i>`,
          color: "danger",
          position: "top-right",
          title: res.mensaje,
        });
      }
      this.row.Descripcion = "";
    },
    async deleteCategoriaAcademia(id) {
      let res = await this.$store.dispatch("hl_delete", {
        path: "CategoriasCursos/EliminarCategoriaCurso/" + id,
      });
      this.getCategoriasCursos();
      console.log("ln-1759 -----", res);
      if (res.respuesta) {
        this.$vs.notification({
          // duration: "none",
          progress: "auto",
          icon: `<i class='fas fa-circle-check'></i>`,
          color: "primary",
          position: "top-right",
          title: res.mensaje,
        });
      } else {
        this.$vs.notification({
          // duration: "none",
          progress: "auto",
          icon: `<i class='fas fa-xmark'></i>`,
          color: "danger",
          position: "top-right",
          title: res.mensaje,
        });
      }
    },
    onResize() {
      this.listaCursosAcademia.forEach((_, index) => {
        this.checkDescripcionLength(index);
      });
    },
    async getInfoClasesCursoAcademia(cursoId) {
      try {
        this.LoadingCursos = true;
        this.activeCardVideoClase = null;
        this.listaContenidoClases = [];
        this.filterDataModalUpdateCurso = this.listaCursosAcademia.find(
          (curso) => curso.id === cursoId
        );

        let res = await this.$store.dispatch("hl_get", {
          path: `ClasesCursosAcademia/ObtenerClasesPorCurso/${cursoId}`,
        });
        if (res.respuesta) this.clases = res.data;
        else {
          this.clases = [];
        }
        this.LoadingCursos = false;
      } catch (error) {
        console.log("err", error);
        this.LoadingCursos = false;
      }
    },
    async getListCursosAcademia() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path:
            "CursosAcademia/ObtenerClasesAll/" +
            this.persona.id +
            "/" +
            this.persona.empresa.id +
            "?salta=0&toma=8",
        });

        if (res.respuesta) {
          // Transformamos PreviewImagenUrl
          let ImgDrive = res.data.map((curso) => {
            return {
              ...curso,
              previewImagenUrl: curso.previewImagenUrl,
            };
          });

          this.listaCursosAcademia = ImgDrive;

          if (this.listaCursosAcademia.length < 8) this.hasMore = false;
        } else {
          this.listaCursosAcademia = [];
        }

        await this.$store
          .dispatch("hl_get", {
            path: "CursosAcademia/ObtenerClasesResponsable/" + this.persona.id,
          })
          .then((response) => {
            if (response.respuesta) {
              this.ListaCursosSelect = response.data;
            }
          });
      } catch (error) {
        this.listaCursosAcademia = [];
      }
    },

    async addCursoAcademia() {
      try {
        this.isLoading = !this.isLoading;
        const imageUrl = this.imagePreview
          ? await this.uploadVistaPreviaImagenCurso()
          : null;
        if (imageUrl == null) {
          this.isLoading = false;
          return;
        }
        this.newCourse = {
          ...this.newCourse,
          responsableId: this.persona.id,
          previewImagenUrl: imageUrl,
          ultimaActualizacion: this.$moment
            .tz(new Date(), "America/Bogota")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };

        let res = await this.$store.dispatch("hl_post", {
          path: "CursosAcademia",
          data: this.newCourse,
        });
        if (res.success) {
          this.getListCursosAcademia();
          this.$vs.notification({
            // duration: "none",
            progress: "auto",
            icon: `<i class='fas fa-circle-check'></i>`,
            color: "primary",
            position: "top-right",
            title: "Registro guardado correctamente!",
          });
          this.initFormNewCourse();
          this.isLoading = !this.isLoading;
        } else {
          this.$vs.notification({
            // duration: "none",
            progress: "auto",
            icon: `<i class='fas fa-xmark'></i>`,
            color: "danger",
            position: "top-right",
            title: "Ha ocurrido un error!",
            text: res.errorDetail,
          });
          this.isLoading = !this.isLoading;
        }
      } catch (error) {
        this.$vs.notification({
          // duration: "none",
          progress: "auto",
          icon: `<i class='fas fa-xmark'></i>`,
          color: "danger",
          position: "top-right",
          title: "Ha ocurrido un error!",
          text: error,
        });
        this.isLoading = !this.isLoading;
      }
    },
    async addClaseCursoAcademia() {
      try {
        this.isLoading = true;
        const data = {
          ...this.newClase,
          cursoAcademiaId: this.filterDataModalUpdateCurso.id,
          responsableId: this.persona.id,
          ultimaActualizacion: this.$moment
            .tz(new Date(), "America/Bogota")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };
        let res = await this.$store.dispatch("hl_post", {
          path: "ClasesCursosAcademia/",
          data: data,
        });
        await this.getInfoClasesCursoAcademia(this.cursoId);
        this.$bvModal.hide("modalAgregarClase");
        if (res.success) {
          this.$vs.notification({
            progress: "auto",
            icon: `<i class='fas fa-circle-check'></i>`,
            color: "primary",
            position: "top-right",
            title: "Registro guardado correctamente!",
          });
          this.newClase = {
            titulo: "",
            descripcion: "",
            // duracion: "",
            urlClaseVideo: "",
            cursoAcademiaId: null,
            ultimaAcatualizacion: "",
            responsableId: null,
          };
          this.isLoading = false;
        } else {
          this.$vs.notification({
            // duration: "none",
            progress: "auto",
            icon: `<i class='fas fa-xmark'></i>`,
            color: "danger",
            position: "top-right",
            title: "Ha ocurrido un error!",
            text: res.errorDetail,
          });
          this.isLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.$vs.notification({
          // duration: "none",
          progress: "auto",
          icon: `<i class='fas fa-xmark'></i>`,
          color: "danger",
          position: "top-right",
          title: "Ha ocurrido un error!",
          text: error,
        });
        this.isLoading = !this.isLoading;
      }
    },
    async updateCursoAcademia() {
      try {
        this.isLoading = true;

        let imageUrl = this.filterDataModalUpdateCurso.previewImagenUrl;

        if (this.imagenCambiada && this.file) {
          imageUrl = await this.uploadVistaPreviaImagenCurso();

          if (imageUrl === "Error al subir archivo") {
            this.isLoading = false;
            return;
          }
        }

        this.filterDataModalUpdateCurso = {
          ...this.filterDataModalUpdateCurso,
          previewImagenUrl: imageUrl,
          ultimaActualizacion: this.$moment
            .tz(new Date(), "America/Bogota")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };

        delete this.filterDataModalUpdateCurso.responsable;
        delete this.filterDataModalUpdateCurso.categoriaCurso;

        let res = await this.$store.dispatch("hl_post", {
          path: "CursosAcademia/Update/",
          data: this.filterDataModalUpdateCurso,
        });

        await this.getListCursosAcademia();
        this.$bvModal.hide("modalUpdateCurso");

        if (res.success) {
          this.$vs.notification({
            icon: `<i class='fas fa-circle-check'></i>`,
            color: "primary",
            position: "top-right",
            title: "Registro actualizado correctamente!",
          });
        } else {
          this.$vs.notification({
            icon: `<i class='fas fa-xmark'></i>`,
            color: "danger",
            position: "top-right",
            title: "Ha ocurrido un error!",
            text: res.errorDetail,
          });
        }

        // ✅ Restablecer bandera al terminar
        this.imagenCambiada = false;

      } catch (error) {
        this.$vs.notification({
          icon: `<i class='fas fa-xmark'></i>`,
          color: "danger",
          position: "top-right",
          title: "Error al actualizar curso",
          text: error.message || error,
        });
      } finally {
        this.isLoading = false;
      }
    },


    async updateClaseCursoAcademia() {
      try {
        this.isLoading = !this.isLoading;
        const data = {
          ...this.filterDataModalUpdateClase,
          ultimaActualizacion: this.$moment
            .tz(new Date(), "America/Bogota")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };
        let res = await this.$store.dispatch("hl_post", {
          path: "ClasesCursosAcademia/Update/",
          data,
        });
        if (res.success) {
          await this.getInfoClasesCursoAcademia(this.cursoId);
          this.$bvModal.hide("modalUpdateClase");
          this.onResize();
          this.$vs.notification({
            // duration: "none",
            progress: "auto",
            icon: `<i class='fas fa-circle-check'></i>`,
            color: "primary",
            position: "top-right",
            title: "Registro actualizado correctamente!",
          });
          this.isLoading = !this.isLoading;
        } else {
          this.$vs.notification({
            // duration: "none",
            progress: "auto",
            icon: `<i class='fas fa-xmark'></i>`,
            color: "danger",
            position: "top-right",
            title: "Ha ocurrido un error!",
            text: res.errorDetail,
          });
          this.isLoading = !this.isLoading;
        }
      } catch (error) {
        console.log(error);
        this.$vs.notification({
          // duration: "none",
          progress: "auto",
          icon: `<i class='fas fa-xmark'></i>`,
          color: "danger",
          position: "top-right",
          title: "Ha ocurrido un error!",
          text: error,
        });
        this.isLoading = !this.isLoading;
      }
    },
    async deleteCursoAcademia(id) {
      Swal.fire({
        title: "¿Seguro que deseas eliminar el registro?",
        text: "Después de eliminarlo no podrás recuperarlo.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#186bdd",
        cancelButtonColor: "#F2135D",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (!result.isConfirmed) return;

        try {
          const res = await this.$store.dispatch("hl_delete", {
            path: `CursosAcademia/Delete/${id}`,
          });

          if (res.success) {
            const index = this.listaCursosAcademia.findIndex(
              (curso) => curso.id === id
            );
            if (index !== -1) this.listaCursosAcademia.splice(index, 1);

            this.$vs.notification({
              progress: "auto",
              icon: `<i class='fas fa-circle-check'></i>`,
              color: "primary",
              position: "top-right",
              title: "Registro eliminado correctamente.",

            });
          } else {
            let mensajeError = res.message || "Error al eliminar el curso.";

            if (mensajeError.includes("asociado")) {
              mensajeError =
                "No se puede eliminar el curso porque tiene registros asociados (por ejemplo, alumnos, contenido, evaluaciones, por favor elimina primero los contenidos y después las clases).";
            } else if (mensajeError.includes("no existe")) {
              mensajeError = "El curso que intentas eliminar no existe.";
            }

            this.$vs.notification({
              progress: "auto",
              icon: `<i class='fas fa-xmark'></i>`,
              color: "danger",
              position: "top-right",
              title: "Error al eliminar el registro",
              text: mensajeError,
              duration: 'none',
            });
          }
        } catch (error) {
          console.error("Error al eliminar curso:", error);
          this.$vs.notification({
            progress: "auto",
            icon: `<i class='fas fa-xmark'></i>`,
            color: "danger",
            position: "top-right",
            title: "Error inesperado",
            text: "Ocurrió un error de conexión o del servidor.",
          });
        }
      });
    },

    async deleteVideoClase(id) {
      await Swal.fire({
        title: "Seguro eliminar registro?",
        text: "Después de eliminarlo no podrás recuperarlo!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#186bdd",
        cancelButtonColor: "#F2135D",
        confirmButtonText: "Si!",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            let res = await this.$store.dispatch("hl_get", {
              path: `ClasesCursosAcademia/Delete/${id}`,
            });
            if (res.success) {
              await this.getInfoClasesCursoAcademia(this.cursoId);
              this.$vs.notification({
                //duration: "none",
                progress: "auto",
                icon: `<i class='fas fa-circle-check'></i>`,
                color: "primary",
                position: "top-right",
                title: "Registro eliminado correctamente!",
              });
            } else {
              this.$vs.notification({
                // duration: "none",
                progress: "auto",
                icon: `<i class='fas fa-xmark'></i>`,
                color: "danger",
                position: "top-right",
                title: "Ha ocurrido un error!",
                text: res.errorDetail,
              });
            }
          } catch (error) {
            console.log("err", error);
            this.$vs.notification({
              // duration: "none",
              progress: "auto",
              icon: `<i class='fas fa-xmark'></i>`,
              color: "danger",
              position: "top-right",
              title: "Ha ocurrido un error!",
              text: error,
            });
          }
        }
      });
    },
    initFormNewCourse() {
      this.newCourse = {
        titulo: "",
        descripcion: "",
        previewImagenUrl: "",
        categoriaCursoId: "",
        certificadoFinalizacion: null,
        Privacidad: false,
        responsableId: null,
        ultimaActualizacion: "",
        notaMinima: null,
        notaMaxima: null,
        InscripcionPublica: false,
      };
      this.imagePreview = null;
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    previewImage(event) {
      const file = event.target.files[0];

      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        this.file = file;
        this.imagePreview = URL.createObjectURL(file);
        this.imagenCambiada = true;
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };

        reader.readAsDataURL(file);
      } else {
        console.error("Por favor, selecciona una imagen.");
      }
    },
    removeImage() {
      this.filterDataModalUpdateCurso.previewImagenUrl = null;
      // Restablecer el valor del input de archivo para permitir seleccionar la misma imagen nuevamente
      this.$refs.fileInput.value = null;
    },

    async cardActiveClase(index) {
      this.$set(this.loadingStates, index, true);
      this.LoadingContenidos = true;
      this.activeCardVideoClase = index;
      this.filterDataModalUpdateClase = this.clases[index];

      await this.$store
        .dispatch("hl_get", {
          path:
            "ContenidoClasesCursosAcademia/ObtenerContenidos/" +
            this.filterDataModalUpdateClase.id,
        })
        .then((res) => {
          if (res.respuesta) {
            this.listaContenidoClases = res.data;
          } else {
            this.listaContenidoClases = [];
          }
        });

      this.$set(this.loadingStates, index, false);
      this.$nextTick(() => {
        this.$refs.collapseRefsClass?.[index]?.show?.();
      });
    },

    async getCategoriasCursos() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path:
            "CategoriasCursos/ObtenerCategoriasCurso/" +
            this.persona.empresa.id,
        });
        this.listaCategoriaCursos = res;
      } catch (error) {
        this.listaCategoriaCursos = [];
        console.log("err", error);
      }
    },
    async renameFile(nameFile) {
      let collectionBad = "á é í ó ú Á É Í Ó Ú ñ Ñ";
      let collectionGood = "a e i o u A E I O U n N";
      let collectionBadA = collectionBad.split(" ");
      let collectionGoodA = collectionGood.split(" ");
      let count = 0;
      for await (let it of collectionBadA) {
        let pos = nameFile.indexOf(it);
        if (pos > 0) {
          nameFile = nameFile.replaceAll(it, collectionGoodA[count]);
        }
        pos = 0;
        count++;
      }
      return nameFile;
    },
    async uploadVistaPreviaImagenCurso() {
      try {
        // Este método lo que hace es renombrar el archivo, eliminando caracteres especiales y acentos
        this.filename = await this.renameFile(this.file.name);

        if (this.filename != null) {
          let nameEmpresa = this.persona.empresa.nombre;
          let idEmpresa = this.persona.empresa.id;
          let nombreCurso =
            this.newCourse.titulo == ""
              ? this.filterDataModalUpdateCurso.titulo
              : this.newCourse.titulo;
          console.log(
            "[uploadVistaPreviaImagenCurso] nombreCurso",
            nombreCurso
          );
          let remoteFilePath = `/cursosAcademia/${nameEmpresa.replace(
            /\s/g,
            ""
          )} - ${idEmpresa}/1.Portadas/${nombreCurso.replace(/\s/g, "")} - ${this.filename
            }`;

          console.log("URL: " + remoteFilePath);
          let uploadImg = await this.$store.dispatch("onFileCustomDrive", {
            //filename: this.filename,
            file: this.file,
            remoteFilePath: remoteFilePath,
            soloImagenes: true,
          });
          if (uploadImg.respuesta) {
            this.$vs.notification({
              progress: "auto",
              icon: `<i class='fas fa-circle-check'></i>`,
              color: "primary",
              position: "top-right",
              title: uploadImg.mensaje || "Imagen subida correctamente.",
            });

            console.log("archivo subido...", uploadImg);
            return uploadImg.data;
          } else {
            this.$vs.notification({
              progress: "auto",
              icon: `<i class='fas fa-xmark'></i>`,
              color: "danger",
              position: "top-right",
              title: "Error al subir archivo",
              text: uploadImg.mensaje || "No se pudo subir la imagen.",
              duration: 'none'
            });
            return "Error al subir archivo";
          }
        }
      } catch (error) {
        console.log("errror upload", error);
      }
    },
    checkDescripcionLength(index) {
      this.$nextTick(() => {
        const parrafoElement =
          this.$el.querySelectorAll(".content-desc p")[index];

        if (parrafoElement) {
          if (parrafoElement.scrollHeight > parrafoElement.clientHeight) {
            this.$set(this.showReadMoreDesc, index, true);
          } else {
            this.$set(this.showReadMoreDesc, index, false);
          }
        }
      });
      return false;
    },
    async habilitarCurso(idCurso) {
      await this.$store
        .dispatch("hl_post", {
          path: "CursosAcademia/HabilitarCurso/" + idCurso,
        })
        .then((response) => {
          if (response.respuesta) {
            Swal.fire("Listo!", response.mensaje, "success");
            this.$bvModal.hide("modalAdminCurso");
            this.getListCursosAcademia();
          } else {
            Swal.fire("Error", response.mensaje, "error");
          }
        });
    },
    async DeshabilitarCurso(idCurso) {
      const confirmacion = await Swal.fire({
        title: "¿Desea deshabilitar el curso?",
        text: "Esta acción inactivará el curso y no estará disponible para los estudiantes.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, deshabilitar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      });

      if (confirmacion.isConfirmed) {
        try {
          const response = await this.$store.dispatch("hl_post", {
            path: "CursosAcademia/DeshabilitarCurso/" + idCurso,
          });

          if (response.respuesta) {
            Swal.fire("Listo!", response.mensaje, "success");
            this.$bvModal.hide("modalAdminCurso");
            this.getListCursosAcademia();
          } else {
            Swal.fire("Error", response.mensaje, "error");
          }
        } catch (error) {
          Swal.fire("Error", "No se pudo deshabilitar el curso.", "error");
          console.error(error);
        }
      }
    },

    async ClonarCurso(idCurso) {
      await this.$store
        .dispatch("hl_post", { path: "CursosAcademia/ClonarCurso/" + idCurso })
        .then((response) => {
          if (response.respuesta) {
            Swal.fire("Listo!", response.mensaje, "success");
            this.getListCursosAcademia();
          } else {
            Swal.fire("Error", response.mensaje, "error");
          }
        });
    },

    // metodos Seguimiento
    async fetchData({ filtro, orden, cantDatos, paginacion }) {
      let params = {
        filtro: filtro,
        orden: orden,
        cantDatos: cantDatos,
        paginacion: paginacion,
      };
      let data = [];
      let total = 0;

      await Promise.all([
        this.$store.dispatch("hl_get", {
          path: `SeguimientoPersonasCursos/ObtenerCantidadSeguimientoPersonasCurso?cursoId=${this.cursoSeguimientoId}&ResponsableID=${this.persona.id}&filtro=${params.filtro}`,
        }),
        this.$store.dispatch("hl_post", {
          path:
            "SeguimientoPersonasCursos/ObtenerSeguimientoPersonasCurso?cursoId=" +
            this.cursoSeguimientoId +
            "&ResponsableId=" +
            this.persona.id,
          data: params,
        }),
      ]).then(([cantidadDatos, Datos]) => {
        if (cantidadDatos.respuesta) {
          total = cantidadDatos.data;
        }
        if (Datos.respuesta) {
          data = Datos.data;
          data.forEach((Element) => {
            Element.FechaInicio = this.$moment
              .tz(Element.FechaInicio, "America/Bogota")
              .format("MM-DD-YYYY");
            if (Element.FechaFinalizacion)
              Element.FechaFinalizacion = this.$moment
                .tz(Element.FechaFinalizacion, "America/Bogota")
                .format("MM-DD-YYYY");
            Element.Completado = Element.Completado ? "Finalizado" : "En curso";

            this.datosSeguimiento = data;

          });
        }
      });
      return { total, data };
    },
    async fetchDataSeguimiento({ filtro, orden, cantDatos, paginacion }) {
      let params = {
        filtro: filtro,
        orden: orden,
        cantDatos: cantDatos,
        paginacion: paginacion,
      };
      let data = [];
      let total = 0;

      await Promise.all([
        this.$store.dispatch("hl_get", {
          path: `SeguimientoPersonasCursos/ObtenerSeguimientoPersonasContenidosCursoFaltantesCantidad?cursoId=${this.cursoSeguimientoId}&filtro=${params.filtro}&EmpresaId=${this.EmpresaId}`,
        }),
        this.$store.dispatch("hl_post", {
          path:
            "SeguimientoPersonasCursos/ObtenerSeguimientoPersonasContenidosCursoFaltantes?cursoId=" +
            this.cursoSeguimientoId +
            "&EmpresaId=" +
            this.EmpresaId,
          data: params,
        }),
      ]).then(([cantidadDatos, Datos]) => {
        if (cantidadDatos.respuesta) {
          total = cantidadDatos.data;
        }
        if (Datos.respuesta) {
          data = Datos.data;
        }
      });
      return { total, data };
    },
    async ObtenerSeguimientoCurso(idCurso) {
      this.activeTab = 2;
      this.cursoSeguimientoId = idCurso;
      this.$refs.dataTableLotes.$emit("actualizar");
    },
    async obtenerNotas(idCurso, personaId) {
      this.NotasCurso = [];
      this.personaSelect = personaId;
      await this.$store
        .dispatch("hl_get", {
          path:
            "CursosAcademia/ObtenerNotas/" + idCurso + "/persona/" + personaId,
        })
        .then((response) => {
          if (response.respuesta) {
            this.NotasCurso = response.data.Notas.map((element) => ({
              ...element,
              FechaInicio: element.FechaInicio
                ? this.$moment
                  .tz(element.FechaInicio, "America/Bogota")
                  .format("YYYY-MM-DDTHH:mm")
                : null,
              FechaFin: element.FechaFin
                ? this.$moment
                  .tz(element.FechaFin, "America/Bogota")
                  .format("YYYY-MM-DDTHH:mm")
                : null,
              FechaAplicacion: element.FechaAplicacion
                ? this.$moment
                  .tz(element.FechaAplicacion, "America/Bogota")
                  .format("YYYY-MM-DDTHH:mm")
                : null,
            }));
          }
        });
      this.$bvModal.show("modalEvaluacionesAdministracion");
    },
    async guardarFecha(FechaInicio, FechaFin, evaluacionId) {
      let dataSend = {
        FechaInicio: FechaInicio,
        FechaFin: FechaFin,
      };
      await this.$store
        .dispatch("hl_post", {
          path:
            "EvaluacionesAcademia/ModificarTiempoAplicacionEvaluacion/" +
            evaluacionId +
            "/persona/" +
            this.personaSelect,
          data: dataSend,
        })
        .then((res) => {
          if (res.respuesta) {
            Swal.fire("Listo!", "Fecha actualizada correctamente.", "success");
          } else {
            Swal.fire("Error", res.mensaje, "error");
          }
        });
    },
    AbrilModalSeguimiento() {
      this.VisibleSeguimiento = true;
    },
    async IniciarSeguimientoPersonas() {
      try {
        this.BotonCargaAgregarPersonas = true;
        await this.$store
          .dispatch("hl_post", {
            path:
              "SeguimientoPersonasCursos/IniciarSeguimientoCurso/" +
              this.cursoSeguimientoId,
            data: this.PersonasSeleccionadasInicioCurso,
          })
          .then((response) => {
            if (response.respuesta) {
              Swal.fire("Listo!", response.mensaje, "success");
              this.$refs.dataTableLotes.$emit("actualizar");
            } else {
              Swal.fire("Error", response.mensaje, "error");
            }
          })
          .finally(() => {
            this.VisibleSeguimiento = false;
            this.$refs.dataTableSeguimiento.$emit("actualizar");
          });
        this.BotonCargaAgregarPersonas = false;
      } catch (error) {
        console.log("err", error);
        this.BotonCargaAgregarPersonas = false;
        this.$refs.dataTableSeguimiento.$emit("actualizar");
      }
    },
    formatoFechaHora(fecha) {
      if (!fecha) return "Fecha No Registrada";

      const fechaObj = new Date(fecha);
      const opcionesFecha = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      const opcionesHora = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };

      const fechaFormateada = fechaObj.toLocaleDateString(
        "es-CO",
        opcionesFecha
      );
      const horaFormateada = fechaObj.toLocaleTimeString("es-CO", opcionesHora);

      return `${fechaFormateada} ${horaFormateada}`;
    },

    //Carga Retrasada
    handleScroll() {
      const container = this.$refs.cursosContainer;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 10 &&
        !this.isLoading &&
        this.hasMore
      )
        this.loadCursos();
    },
    async loadCursos() {
      if (this.isLoadingCurso || !this.hasMore) return;
      this.isLoadingCurso = true;
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: `CursosAcademia/ObtenerClasesAll/${this.persona.id}/${this.persona.empresa.id}?salta=${this.Paginacion}&toma=8&titulo=${this.searchedTitleCursos}`,
        });

        if (res.respuesta && res.data.length > 0) {
          this.Paginacion += 1;
          this.listaCursosAcademia.push(...res.data);
        } else {
          this.hasMore = false; // No hay más cursos para cargar
        }
      } catch (error) {
        console.error("Error cargando cursos:", error);
      } finally {
        this.isLoadingCurso = false; // Se desbloquean nuevas peticiones
      }
    },
    async BuscarPorTitulo() {
      this.Paginacion = 0;
      this.hasMore = true;
      this.listaCursosAcademia = [];
      await this.loadCursos();
    },

    //Carga masiva
    handleFileUpload(event) {
      const file = event;
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Tomar la primera hoja
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convertir a JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // Extraer encabezados y datos
        this.headers = jsonData[0] || [];
        this.excelData = jsonData.slice(1);

        // Validar que el archivo tenga solo el encabezado esperado
        if (
          this.headers.length !== 1 ||
          this.headers[0] !== "Numero Documento"
        ) {
          this.mostrarNotificacion(
            "error",
            "Archivo inválido",
            'El archivo Excel debe contener únicamente la columna "Numero Documento".'
          );
          this.limpiarDatosExcel();
          return;
        }

        // Extraer solo los documentos (primera columna)
        this.DocumentosMasivos = this.excelData
          .map((fila) => fila[0]?.toString().trim())
          .filter((doc) => doc); // elimina filas vacías

        console.log("Documentos: ", this.DocumentosMasivos);

        // Validar que existan datos
        if (this.DocumentosMasivos.length === 0) {
          this.mostrarNotificacion(
            "error",
            "Ingrese información",
            "El archivo Excel no contiene documentos válidos."
          );

          return;
        }
      };

      reader.readAsArrayBuffer(file);
    },
    limpiarDatosExcel() {
      this.DocumentosMasivos = [];
      this.$refs.DropFileBasic.restaurar();
    },
    mostrarNotificacion(tipo, titulo, mensaje) {
      Swal.fire({
        icon: tipo,
        title: titulo,
        text: mensaje,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
    },
    async traerIdPersonasMasivas() {
      try {
        let PersonaId = await this.$store.dispatch("hl_post", {
          path: `SeguimientoPersonasCursos/ObtenerPersonasMasivasCursoFaltantesPorCedulas/${this.cursoSeguimientoId}`,
          data: this.DocumentosMasivos,
        });

        if (PersonaId.respuesta) {
          if (this.$refs.dataTableLotes) {
            this.PersonasSeleccionadasInicioCurso = PersonaId.data;
            this.$refs.dataTableLotesSeguimiento.$emit(
              "EstablecesDatoSeleccionadosMultiples",
              PersonaId.data
            );
            this.limpiarDatosExcel();
            this.CargaMasivaVisible = false;
          }
        }
      } catch (error) {
        console.error("Error al traer ID de personas masivas:", error);
      }
    },
    descargarFormatoExcel() {
      // Crear hoja con encabezado
      const worksheet = XLSX.utils.aoa_to_sheet([["Numero Documento"]]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Formato");

      // Generar archivo
      XLSX.writeFile(workbook, "Formato_Carga_Personas.xlsx");
    },

    resetRow() {
      this.row = {}
    }
  },
  computed: {
    filterVideosClase() {
      const clases = this.clases || [];
      return clases.filter((clase) =>
        clase.titulo
          .toLowerCase()
          .includes(this.searchedTitleClase.toLowerCase())
      );
    },
    filterCategorias() {
      const listaCategoria = this.listaCategoriaCursos.data || [];
      return listaCategoria.filter((categoria) =>
        categoria.Descripcion.toLowerCase().includes(
          this.searchedTitleCategoria.toLowerCase()
        )
      );
    },
    filterContenidoClases() {
      const resultado = this.listaContenidoClases.filter((contenido) =>
        contenido.Titulo.toLowerCase().includes(
          this.searchedTitleClase.toLowerCase()
        )
      );
      console.log("Elementos filtrados:", resultado); // Muestra los elementos que cumplen con la búsqueda
      return resultado;
    },
  },
  filters: {
    formatLastUpdateDate(fechaOriginal) {
      return moment_timezone
        .tz(fechaOriginal, "America/Bogota")
        .format("MMM D, YYYY");
    },
  },
};
</script>

<style scoped type="scss">
@import url("https://unpkg.com/vue-select@3.20.2/dist/vue-select.css");

.image-container-preview {
  display: flex;
}

.image-container-preview img {
  border-radius: 5px;
  width: 200px;
  height: 90px;
  object-fit: cover;
}

.video-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  /* Proporción 16:9 (9 / 16 = 0.5625 o 56.25%) */
  margin-top: 20px;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.video-container-yt {
  width: 100% !important;
}

.responsive-iframe-yt {
  /* position: absolute;
  top: 0;
  left: 0; */
  width: 100%;
  height: 300px;
  /* border: none;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}

.vs-notification__content__text {
  color: rgb(192, 192, 192) !important;
}

.vista-previa {
  position: relative;
  width: 100%;
  min-height: 300px;
}

.list-videos {
  max-height: 600px;
  overflow-y: scroll;
  gap: 1rem;
}

/* image preview */
.image-container {
  position: relative;
  height: 300px;
  border: 2px dashed #3498db;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

.placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #777;
  cursor: pointer;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  border-radius: 5px;
}

/* parrafo corto */
.custom-descripcion {
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  /* Número de líneas a mostrar */
  -webkit-box-orient: vertical;
}

@media (min-width: 0px) and (max-width: 1024px) {
  .image-container-preview {
    display: flex;
    width: 100% !important;
    z-index: 3 !important;
    margin-left: auto;
    margin-right: auto;
  }

  .image-container-preview img {
    display: block;
    margin: auto;
    border-radius: 5px;
    width: 500px;
    height: 300px;
    object-fit: cover;
  }
}
</style>
